import {
  IBatchFatpGenealogyDevice,
  IBulkUploadResult,
  IDataOverviewDevice,
  IDataOverviewProgress,
  IFamilySpecDetail,
  IFamilySpecSummary,
  IFATPConfigItem,
  IFATPDataSeries,
  IFatpGenealogyItem,
  IFATPParameterDataGroup,
  IFATPParameterItem,
  IFatpReadoutOption,
  IFATPViewerReadoutTreeTest,
  IMajorReadoutItem,
  IReadoutListItem,
  IReadoutMappingItem,
  IRealDSNItem,
  ITestSpec,
  ITestSpecBase,
  ITestStatusItem,
  ITestVariableSelection,
  IWaterfallImportChange,
  TDataOverviewBeStatus,
  TDeviceTestWaterfall,
  TFATPGenealogyRequest,
  TIdentifier,
  TShareableInfo,
  TTestDuration,
  TTestSpecDetail,
  TTestStatusIssue,
  TUserList,
} from "@/type/axios";
import { axiosMockAdapterInstance } from "@services/axios";
import apiConfig from "@services/env";
// TestWaterfall Timeline Overview mock data
import { TestWaterfallStatus, TTestWaterfallStatus } from "@/constants/Test";
import { TTestWaterfallConfidence } from "@/type/axios";
import { IConfig } from "@/type/router";

// Configuration arrays for generating varied mock data
const buildConfigs = ["H-DOE1", "H-DOE2", "H-DOE3", "Config1", "Config2", "Config3", "Config4", "Config5", "HF1", "HF2", "Standard", "Premium"];
const families = ["Tablet", "Phone", "Watch", "Speaker", "Display", "Camera"];
const projects = ["Tungsten", "Titanium", "Platinum", "Cobalt", "Nickel", "Chrome", "Zinc", "Iron"];
const phases = ["DVT", "EVT", "PVT", "HVT", "ORT", "MP"];
const builds = ["1.0", "1.1", "2.0", "2.1", "3.0"];
const statuses: TTestWaterfallStatus[] = [TestWaterfallStatus.PASS, TestWaterfallStatus.FAIL, TestWaterfallStatus.ONGOING, TestWaterfallStatus.NOT_STARTED, TestWaterfallStatus.CANCELLED, TestWaterfallStatus.OBSERVATION];

// Test definitions with realistic names and durations
const testDefinitions = [
  { sequnce: "Rear A", id: "baseline_check_1", name: "Baseline Check Test - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "baseline_check_2", name: "Baseline Check Test - Lv2", duration: 2 },
  { sequnce: "Rear A", id: "operational_corner_1", name: "Operational Corner Test - Lv1", duration: 2 },
  { sequnce: "Rear A", id: "operational_corner_2", name: "Operational Corner Test - Lv2", duration: 3 },
  { sequnce: "Rear A", id: "free_drop_gn_1", name: "Standard Free Drop Test - GN - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "free_drop_gn_2", name: "Standard Free Drop Test - GN - Lv2", duration: 2 },
  { sequnce: "Rear A", id: "temp_humidity_1", name: "Temperature and Humidity Cycling Test - Lv1", duration: 4 },
  { sequnce: "Rear A", id: "temp_humidity_2", name: "Temperature and Humidity Cycling Test - Lv2", duration: 5 },
  { sequnce: "Rear A", id: "thermal_cycling_1", name: "Thermal Cycling Test - Lv1", duration: 3 },
  { sequnce: "Rear A", id: "thermal_cycling_2", name: "Thermal Cycling Test - Lv2", duration: 4 },
  { sequnce: "Rear A", id: "random_vibration_1", name: "Random Vibration Test - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "random_vibration_2", name: "Random Vibration Test - Lv2", duration: 2 },
  { sequnce: "Rear A", id: "ball_impact_front", name: "Ball Impact Front Side Test - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "ball_impact_rear_a", name: "Ball Impact Back Side Test - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "ball_impact_rear_b", name: "Ball Impact Back Side Test - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "liquid_detection_1", name: "Liquid Detection Test - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "liquid_detection_2", name: "Liquid Detection Test - Lv2", duration: 2 },
  { sequnce: "Rear A", id: "thermal_test_1", name: "Thermal Test A - Lv1", duration: 2 },
  { sequnce: "Rear A", id: "thermal_test_2", name: "Thermal Test B - Lv1", duration: 2 },
  { sequnce: "Rear A", id: "vibration_test_1", name: "Vibration Test A - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "vibration_test_2", name: "Vibration Test B - Lv1", duration: 1 },
  { sequnce: "Rear A", id: "solar_exposure_1", name: "Solar Exposure Test - Lv1", duration: 3 },
  { sequnce: "Rear A", id: "solar_exposure_2", name: "Solar Exposure Test - Lv2", duration: 4 },
  { sequnce: "Rear A", id: "dust_resistance_1", name: "Dust Resistance Test - Lv1", duration: 2 },
  { sequnce: "Rear B", id: "water_immersion_1", name: "Water Immersion Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "water_immersion_2", name: "Water Immersion Test - Lv2", duration: 2 },
  { sequnce: "Rear B", id: "esd_test_1", name: "ESD Air Discharge Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "esd_test_2", name: "ESD Contact Discharge Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "mechanical_shock_1", name: "Mechanical Shock Test - Lv1", duration: 2 },
  { sequnce: "Rear B", id: "mechanical_shock_2", name: "Mechanical Shock Test - Lv2", duration: 3 },
  { sequnce: "Rear B", id: "altitude_test_1", name: "High Altitude Test - Lv1", duration: 2 },
  { sequnce: "Rear B", id: "salt_fog_1", name: "Salt Fog Corrosion Test - Lv1", duration: 4 },
  { sequnce: "Rear B", id: "acoustic_test_1", name: "Acoustic Performance Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "acoustic_test_2", name: "Acoustic Performance Test - Lv2", duration: 2 },
  { sequnce: "Rear B", id: "battery_cycle_1", name: "Battery Cycle Life Test - Lv1", duration: 5 },
  { sequnce: "Rear B", id: "battery_cycle_2", name: "Battery Cycle Life Test - Lv2", duration: 7 },
  { sequnce: "Rear B", id: "display_quality_1", name: "Display Quality Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "touch_accuracy_1", name: "Touch Accuracy Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "wifi_performance_1", name: "WiFi Performance Test - Lv1", duration: 2 },
  { sequnce: "Rear B", id: "bluetooth_test_1", name: "Bluetooth Connectivity Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "gps_accuracy_1", name: "GPS Accuracy Test - Lv1", duration: 2 },
  { sequnce: "Rear B", id: "camera_quality_1", name: "Camera Image Quality Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "sensor_calibration_1", name: "Sensor Calibration Test - Lv1", duration: 1 },
  { sequnce: "Rear B", id: "power_consumption_1", name: "Power Consumption Test - Lv1", duration: 3 },
  { sequnce: "Rear A", id: "charging_test_1", name: "Charging Performance Test- Lv1", duration: 2 },
  { sequnce: "Rear B", id: "charging_test_2", name: "Charging Performance Test- Lv2", duration: 2 },
];

// Issue definitions for realistic failure scenarios
const issueDefinitions = [
  { id: "1147", description: "Device - Can't Power on", type: "observation" },
  { id: "1157", description: "Device - AFT Fail", type: "failure" },
  { id: "1470", description: "Display, Top left - scramble", type: "failure" },
  { id: "1471", description: "Display - Dead pixels detected", type: "failure" },
  { id: "1472", description: "Display - Backlight bleeding", type: "observation" },
  { id: "1501", description: "Battery - Abnormal drain", type: "observation" },
  { id: "1502", description: "Battery - Swelling detected", type: "failure" },
  { id: "1503", description: "Battery - Charging failure", type: "failure" },
  { id: "1601", description: "Touch - Unresponsive area", type: "failure" },
  { id: "1602", description: "Touch - Ghost touches", type: "observation" },
  { id: "1701", description: "WiFi - Connection drops", type: "observation" },
  { id: "1702", description: "WiFi - Low signal strength", type: "observation" },
  { id: "1801", description: "Bluetooth - Pairing failure", type: "failure" },
  { id: "1901", description: "Camera - Focus issue", type: "observation" },
  { id: "1902", description: "Camera - Color calibration off", type: "observation" },
  { id: "2001", description: "Speaker - Distortion at high volume", type: "observation" },
  { id: "2002", description: "Speaker - No audio output", type: "failure" },
  { id: "2101", description: "Microphone - Low sensitivity", type: "observation" },
  { id: "2201", description: "Button - Stuck or unresponsive", type: "failure" },
  { id: "2301", description: "Connector - Loose USB port", type: "observation" },
  { id: "2401", description: "Enclosure - Visible gap", type: "observation" },
  { id: "2402", description: "Enclosure - Scratch on surface", type: "observation" },
  { id: "2501", description: "Thermal - Overheating under load", type: "failure" },
  { id: "2601", description: "GPS - Inaccurate positioning", type: "observation" },
  { id: "2701", description: "Sensor - Accelerometer drift", type: "observation" },
];

// Helper function to generate random hex string for DSN
function generateHexString(length: number): string {
  const chars = "0123456789ABCDEF";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

// Helper function to generate a date string with offset
function generateDate(baseDate: Date, dayOffset: number, hourOffset = 0): string {
  const date = new Date(baseDate);
  date.setDate(date.getDate() + dayOffset);
  date.setHours(date.getHours() + hourOffset);
  return date.toISOString().slice(0, 19);
}

// Helper function to pick random item from array
function randomPick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

// Helper function to pick random items from array
function randomPickMultiple<T>(arr: readonly T[], min: number, max: number): T[] {
  const count = Math.floor(Math.random() * (max - min + 1)) + min;
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

// Generate test list for a device
function generateTestList(baseDate: Date): TDeviceTestWaterfall["testList"] {
  const numTests = Math.floor(Math.random() * 6) + 1; // 1-6 tests per device
  const selectedTests = randomPickMultiple(testDefinitions, numTests, numTests);

  let currentDayOffset = Math.floor(Math.random() * 5); // Random start within 5 days
  const testList: TDeviceTestWaterfall["testList"] = [];

  selectedTests.forEach((testDef, index) => {
    const status = randomPick(statuses) as TDeviceTestWaterfall["testList"][0]["status"];
    const startHour = Math.floor(Math.random() * 12) + 6; // 6am to 6pm
    const startDate = generateDate(baseDate, currentDayOffset, startHour);
    const endDate = generateDate(baseDate, currentDayOffset + testDef.duration, startHour + Math.floor(Math.random() * 4));

    // Generate actual dates only for started tests
    const hasActualStart = status !== TestWaterfallStatus.NOT_STARTED;
    const hasActualEnd = status === TestWaterfallStatus.PASS || status === TestWaterfallStatus.FAIL || status === TestWaterfallStatus.CANCELLED;

    // Random delay for some tests
    const delay = Math.random() < 0.15 ? Math.floor(Math.random() * 3) + 1 : undefined;

    // Generate issues for failed or ongoing tests
    let issueList: TDeviceTestWaterfall["testList"][0]["issueList"] = [];
    if (status === TestWaterfallStatus.FAIL || (status === TestWaterfallStatus.ONGOING && Math.random() < 0.3)) {
      const numIssues = Math.floor(Math.random() * 2) + 1;
      issueList = randomPickMultiple(issueDefinitions, numIssues, numIssues).map(issue => ({
        issueId: issue.id,
        description: issue.description,
        type: issue.type as "observation" | "failure",
      }));
    }

    const test: TDeviceTestWaterfall["testList"][0] = {
      testId: testDef.id,
      testName: testDef.name,
      sequence: testDef.sequnce,
      status,
      startDate,
      endDate,
      duration: testDef.duration,
      order: index + 1,
      issueList,
    };

    if (hasActualStart) {
      const actualStartOffset = Math.random() < 0.7 ? Math.floor(Math.random() * 2) : -Math.floor(Math.random() * 2);
      test.actualStartDate = generateDate(baseDate, currentDayOffset + actualStartOffset, startHour + Math.floor(Math.random() * 2));
    }

    if (hasActualEnd) {
      const actualEndOffset = Math.random() < 0.6 ? Math.floor(Math.random() * 2) : -Math.floor(Math.random() * 1);
      test.actualEndDate = generateDate(baseDate, currentDayOffset + testDef.duration + actualEndOffset, startHour + Math.floor(Math.random() * 4));
    }

    if (delay) {
      test.delay = delay;
    }

    testList.push(test);
    currentDayOffset += testDef.duration + Math.floor(Math.random() * 2); // Gap between tests
  });

  return testList;
}

// Mirrors the real backend `get_user_info` contract: a FLAT (un-enveloped) body using
// the backend's own field names (`userName`, `firstName`, `role`).
// `normalizeUserInfoResponse` maps this onto the FE `IUser` model.
export const fetch_UserInfo = {
  userName: "jianyihp",
  firstName: "Rex",
  email: "jianyihp@amazon.com",
  role: "dev_team" as const,
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_UserInfo).reply(200, fetch_UserInfo);
const fetch_UserList: TUserList[] = [
  { email: "saveSysMessage", username: "Jianyi HP", login: "jianyihp" },
  { email: "ssdsd", username: "ssdsd", login: "ssdsd" },
  { email: "LoaderFunctionArgs", username: "LoaderFunctionArgs", login: "LoaderFunctionArgs" },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_UserList).reply(200, {
  data: fetch_UserList,
});

// Mock simulates what the real backend sends: structural data (key, path, children, tabs).
// No label, icon, or moduleName — those are frontend concerns enriched by MODULE_REGISTRY.
const fetch_RouterConfig: IConfig[] = [
  {
    key: "ROOT",
    label: "",
    path: "/",
    children: [
      {
        key: "DEFINE",
        label: "",
        path: "/Define",
        children: [
          {
            key: "FAMILY_SPEC",
            label: "",
            path: "/Define/FAMILY_SPEC",
          },
          {
            key: "TEST_SPEC",
            label: "",
            path: "/Define/TestSpec",
            briefDescription: "Manage the full lifecycle of build-level test specifications, including creation, editing, approval workflow tracking, and Leadership Sign-off.",
            detailDescription: `**Permissions**

| Role | Access | Available Actions |
|------|--------|-------------------|
| Admin / Approver | Read-Write | View, edit, add, delete specs; create new Build; submit for approval; request Sign-off |
| Project Owner / ORT Non-PI Owner | Read-Write | Same as above |
| PI Viewer | Read-Only | View spec list and details only; no edit or write operations |
| Non-PI Viewer | Read-Only | Same as above (limited to authorized project phases) |
| Quality Team | Read-Only | Same as above |

Read-only users can see all buttons (Edit, Add Test, Submit for Approval, Create New Build, Delete Test, etc.), but submission will be rejected by the backend and write operations will not succeed.

**Select Project and Build**

Use the top dropdowns to select Project and Phase-Build to load the corresponding spec list. "Recently visited" quick links allow one-click switching to recently accessed projects.

**Spec Readiness Progress Bar**

A three-step progress bar shows overall readiness: Spec Completion → Pending Approval → Sign-off. Hover over each step to view a Checklist and action buttons (e.g. "Request Approval", "Request Sign-off").

**Approval & Sign-off**

Approval flow: In Work → Pending Approval → Approved / Rejected. Sign-off: once all specs are Approved, request Leadership Sign-off from the third step of the progress bar. If rejected, a red warning banner appears at the top of the page.

**Export & Share**

"Actions ▾" → "Export Excel" to export all specs for the current Build. "🔗 Share" copies the page link to clipboard.`,
          },
          { key: "TEST_SETTINGS", label: "", path: "/Define/TestSettings" },
        ],
      },
      {
        key: "PLAN",
        label: "",
        path: "/Plan",
        children: [
          {
            key: "TEST_WATERFALL",
            label: "",
            path: "/Plan/TestWaterfall",
            briefDescription: "Plan and visualize the test sequence waterfall and project timeline for a build, including milestones and attachments.",
            detailDescription: `**Tabs**

- **Test Waterfall Details**: drag-and-drop ordered list of tests for the build, with per-test config (level, duration, sequence). Edit individual tests in a side drawer.
- **Timeline Details**: per-test timeline chart with confidence bands. Edit start/end dates per test, set non-working days, and tune confidence per milestone.
- **Attachments**: timeline-related files (test plans, schedules) uploaded for the build.

**Common actions**

Copy a waterfall from a previous build. Configure build identifiers via the Build Config drawer. Edit milestones and confidence levels for the timeline overview.`,
            tabs: [
              { key: "TEST_WATERFALL_DETAILS", label: "" },
              { key: "TIMELINE_DETAILS", label: "" },
              { key: "TIMELINE_ATTACHMENTS", label: "" },
            ],
          },
          { key: "TEST_ASSIGNMENT", label: "", path: "/Plan/TestAssignment" },
        ],
      },
      {
        key: "EXECUTE",
        label: "",
        path: "/Execute",
        children: [
          { key: "REAL_DSN", label: "", path: "/Execute/RealDSN" },
          { key: "ISSUE_LIST", label: "", path: "/Execute/IssueList" },
          { key: "DATA_OVERVIEW", label: "", path: "/Execute/DataOverview" },
          {
            key: "READOUT_INPUT",
            label: "",
            path: "/Execute/ReadoutInput",
            hideInMenu: true,
            briefDescription: "Enter readout measurements and check results for a device under test, with per-readout status and issue tracking.",
            detailDescription: `**Purpose**

Engineers enter measurement values, check pass/fail outcomes, and log issues for a specific device's readout cycle. Each readout corresponds to one milestone in the test sequence.

**Layout**

- Sidebar: Pre-Test entry plus one row per readout, each with a status dot (Pass / Fail / N/A) and a collapsible rail toggle.
- Header: device identifier summary plus Variables popover.
- Main panel: collapsible sections per check group; rows are color-coded by status with a left-border accent on failures.

**Workflow**

Pick a readout from the sidebar. Toggle each check status. Enter measurement values. Save — the readout's sidebar dot updates to reflect overall status. Open the issue popover on any failed row to attach an issue with severity and description.`,
          },
        ],
      },
      {
        key: "ANALYZE",
        label: "",
        path: "/Analyze",
        children: [
          { key: "FDDD", label: "", path: "/Analyze/FDDD" },
          {
            key: "FA_TRACKER",
            label: "",
            path: "/Analyze/FATracker",
            tabs: [
              { key: "FA_LOG", label: "" },
              { key: "FA_NEW_FINDINGS", label: "" },
            ],
          },
          {
            key: "FATP_VIEWER",
            label: "",
            path: "/Analyze/FATPViewer",
            briefDescription: "Visualize FATP station measurement data across readouts, devices, and parameters using line charts (sequence) and box plots (independent).",
            detailDescription: `**Data source**

Switch between **Project Data** (live BE: readouts, device buckets, parameters, station data) and **File Import** (uploaded CSV). Source is persisted in the URL via the \`source\` query param so views are shareable.

**Selection**

Pick one or more readouts, devices (by serial), and parameters from the left panels. Selections write to the URL so the chart panel is fully reproducible from the link.

**Charts**

- Sequence parameters render as line charts.
- Independent parameters render as box plots.
- Non-numeric parameters are display-only.

Each chart has per-chart user controls (e.g., scale toggles). Top/bottom limits and min/max range markers are always rendered when defined, regardless of which control is active.`,
          },
          {
            key: "UV_VISUALIZER",
            label: "",
            path: "/Analyze/UVVisualizer",
            briefDescription: "Visualize solar-exposure color-shift (L*a*b* / ΔE) data per build across devices and test locations, with CMC tolerance charts.",
          },
        ],
      },
      {
        key: "MONITOR",
        label: "",
        path: "/Monitor",
        children: [
          { key: "TEST_STATUS", label: "", path: "/Monitor/TestStatus" },
          {
            key: "TEST_SUMMARY",
            label: "",
            path: "/Monitor/TestSummary",
            tabs: [
              { key: "ISSUE_SUMMARY", label: "" },
              { key: "TEST_RESULT", label: "" },
              { key: "TEST_SUMMARY_ATTACHMENTS", label: "" },
            ],
          },
          { key: "TASK_CENTER", label: "", path: "/Monitor/TaskCenter" },
        ],
      },
      {
        key: "ADMIN",
        label: "",
        path: "/Admin",
        children: [
          {
            key: "OPERATOR_MANAGEMENT",
            label: "",
            path: "/Admin/OperatorManagement",
            briefDescription: "Manage Cognito operator accounts at the test location: create, activate/deactivate, delete, and reset or change passwords; view per-operator tracked devices.",
          },
        ],
      },
    ],
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_RouterConfig).reply(200, {
  menus: fetch_RouterConfig,
  isSuccess: true,
  code: 200,
});
const fetch_Project_List: TIdentifier[] = [
  {
    key: "piezo",
    name: "Piezo",
    children: [
      {
        key: "gtk_playground",
        name: "GTK Playground",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "taipei", name: "Taipei" },
          { key: "seattle", name: "Seattle" },
        ],
      },
      {
        key: "baklava_packaging",
        name: "Baklava Packaging",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "dongguan", name: "Dongguan" },
        ],
      },
      {
        key: "cypress",
        name: "Cypress",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "taipei", name: "Taipei" },
        ],
      },
      {
        key: "hypnos",
        name: "Hypnos",
        children: [
          { key: "seattle", name: "Seattle" },
          { key: "austin", name: "Austin" },
        ],
      },
      {
        key: "hoya",
        name: "Hoya",
        children: [{ key: "shenzhen", name: "Shenzhen" }],
      },
    ],
  },
  {
    key: "athena",
    name: "Athena",
    children: [
      {
        key: "laser",
        name: "Laser",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "taipei", name: "Taipei" },
        ],
      },
      {
        key: "crown",
        name: "Crown",
        children: [
          { key: "dongguan", name: "Dongguan" },
          { key: "seattle", name: "Seattle" },
        ],
      },
      {
        key: "croissant",
        name: "Croissant",
        children: [{ key: "shenzhen", name: "Shenzhen" }],
      },
      {
        key: "doebrite",
        name: "Doebrite",
        children: [
          { key: "taipei", name: "Taipei" },
          { key: "austin", name: "Austin" },
        ],
      },
      {
        key: "pascal",
        name: "Pascal",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "seattle", name: "Seattle" },
        ],
      },
      {
        key: "checkers",
        name: "Checkers",
        children: [{ key: "dongguan", name: "Dongguan" }],
      },
    ],
  },
  {
    key: "theia",
    name: "Theia",
    children: [
      {
        key: "crumpet_donut",
        name: "Crumpet Donut",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "taipei", name: "Taipei" },
        ],
      },
      {
        key: "octave",
        name: "Octave",
        children: [{ key: "seattle", name: "Seattle" }],
      },
      {
        key: "sapphire",
        name: "Sapphire",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "dongguan", name: "Dongguan" },
        ],
      },
      {
        key: "kyanite",
        name: "Kyanite",
        children: [
          { key: "taipei", name: "Taipei" },
          { key: "austin", name: "Austin" },
        ],
      },
      {
        key: "pablo",
        name: "Pablo",
        children: [{ key: "shenzhen", name: "Shenzhen" }],
      },
      {
        key: "bishop",
        name: "Bishop",
        children: [
          { key: "seattle", name: "Seattle" },
          { key: "taipei", name: "Taipei" },
        ],
      },
    ],
  },
  {
    key: "cupcake",
    name: "Cupcake",
    children: [
      {
        key: "blink_indoor_camera",
        name: "Blink Indoor Camera",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "dongguan", name: "Dongguan" },
          { key: "seattle", name: "Seattle" },
        ],
      },
      {
        key: "donut",
        name: "Donut",
        children: [{ key: "taipei", name: "Taipei" }],
      },
      {
        key: "lidar",
        name: "Lidar",
        children: [
          { key: "shenzhen", name: "Shenzhen" },
          { key: "austin", name: "Austin" },
        ],
      },
      {
        key: "radar",
        name: "Radar",
        children: [
          { key: "seattle", name: "Seattle" },
          { key: "taipei", name: "Taipei" },
        ],
      },
      {
        key: "muffin",
        name: "Muffin",
        children: [
          { key: "dongguan", name: "Dongguan" },
          { key: "shenzhen", name: "Shenzhen" },
        ],
      },
    ],
  },
];
axiosMockAdapterInstance.onGet(apiConfig.fetch_Project_List).reply(200, {
  data: fetch_Project_List,
});
// axiosMockAdapterInstance.onGet(apiConfig.fetch_Project_List).reply(401, { message: "Access denied - insufficient permissions" });
// axiosMockAdapterInstance.onGet(apiConfig.fetch_Project_List).reply(403, { message: "Access denied - insufficient permissions" });
// axiosMockAdapterInstance.onGet(apiConfig.fetch_Project_List).reply(402, { message: "Access restricted" });

// Generated from phases constant for consistency
const fetch_Phase_List: TIdentifier[] = phases.map(phase => ({
  key: phase.toLowerCase(),
  name: phase,
}));
axiosMockAdapterInstance.onGet(apiConfig.fetch_Phase_List).reply(200, {
  data: fetch_Phase_List,
});
// Generated from phases and builds constants for consistency
const fetch_PhaseBuild_List: TIdentifier[] = phases.map(phase => ({
  key: phase,
  name: phase,
  children: builds.map(build => ({ key: build, name: build })),
}));
axiosMockAdapterInstance.onGet(apiConfig.fetch_PhaseBuild_List).reply(200, {
  data: fetch_PhaseBuild_List,
});
const fetch_Test_List: TIdentifier[] = testDefinitions.map(e => {
  return {
    key: e.id,
    name: e.name,
  };
});
axiosMockAdapterInstance.onGet(apiConfig.fetch_Test_List).reply(200, {
  data: fetch_Test_List,
});

// fetch_TestWithReadout mock data - returns TTestDuration[] with sequence info
// Generated from testDefinitions for consistency
const fetch_TestWithReadout: TTestDuration[] = testDefinitions.slice(0, 15).map((test, index) => ({
  testId: test.id,
  testName: test.name,
  sequence: test.sequnce,
  status: TestWaterfallStatus.NOT_STARTED,
  startDate: "",
  endDate: "",
  order: index + 1,
  issueList: [],
}));
axiosMockAdapterInstance.onGet(apiConfig.fetch_TestWithReadout).reply(200, {
  data: fetch_TestWithReadout,
});

// No projectId is sent: BE returns every Product Family → Sub-Category combination.
const fetch_FamilySubcategory_List: TIdentifier[] = [
  {
    key: "family-tablet",
    name: "Productivity Tablet",
    children: [
      { key: "subcategory-display", name: "Display" },
      { key: "subcategory-battery", name: "Battery" },
    ],
  },
  {
    key: "family-reader",
    name: "E-Reader",
    children: [
      { key: "subcategory-eink", name: "E-Ink Panel" },
      { key: "subcategory-frontlight", name: "Front Light" },
    ],
  },
];
axiosMockAdapterInstance.onGet(apiConfig.fetch_FamilySubcategory_List).reply(200, {
  data: fetch_FamilySubcategory_List,
});
const fetch_ShareableLink: TShareableInfo = {
  identifier: {
    projectId: "gtk_playground",
    phaseId: "EVT",
    buildId: "1",
    test_isd: "test123",
  },
  activeTab: "ss",
  drawer: [
    {
      key: "testDetail",
      // type: "test",
      projectId: "gtk_playground",
      testId: "test125",
      buildId: "1",
      phaseId: "EVT",
    },
  ],
};
axiosMockAdapterInstance.onGet(apiConfig.get_ShareableLink).reply(200, {
  data: fetch_ShareableLink,
});

// Test categories for spec generation
const testCategories = ["Functional", "Performance", "Security", "Usability", "Compatibility", "Regression", "Environmental", "Reliability"];

// Test descriptions templates
const testDescriptionTemplates = [
  "T0 Check:\nVisual Inspection, Diagnostics Check, Performance Check, Mechanical Functionality Check, Connector Force measurement, Button Tactility/Scroll Measurements, Color Measurements, Log files, Hinge Force",
  "Stress testing at 40°C, 50%RH\n- Level 1: 1000 hours\nDevice in operational mode running diag SW.\nCheck point at every 200h, device will be checked in diag and UX mode to ensure component reliability and SW/HW compatibility.",
  "• No issue occurs when running the product diagnostics.\n• No noticeable degradation of system performance occurs.\n• No noticeable mechanical damage occurs.\nTest and MUST PASS Level 1",
  "Assess the user interface for intuitiveness and ease of use. Verify all UI elements are responsive and accessible.",
  "Check application compatibility across different configurations and environments.",
  "Run the full regression test suite to ensure no new issues have been introduced.",
];

// Deterministic approved-baseline row used by e2e (TC-UI-023): a fixed testId whose status is always
// "approved" so tests can open it, toggle Monitor Only, and assert the outgoing edit payload.
export const APPROVED_BASELINE_TEST_ID = "e2e-approved-baseline";

// Helper function to generate test spec list from testDefinitions
function generateTestSpecList(count: number): ITestSpec[] {
  const baseline: ITestSpec = {
    testId: APPROVED_BASELINE_TEST_ID,
    projectId: "gtk_playground",
    phaseId: "DVT",
    buildId: "1.0",
    status: "approved",
    nextStep: ["No"],
    testCategory: "Functional",
    testName: "E2E Approved Baseline Test",
    testDescription: "Deterministic approved baseline for e2e regression coverage.",
    specType: [],
    testLocationId: "jjjs",
    // Family-inherited → renders "(Family Spec_Light-Productivity-Tablet)".
    versionId: "FS_Light-Productivity-Tablet_01",
  };
  const selectedTests = testDefinitions.slice(0, count);
  // Cycle through the three versionId shapes so the Status-column indicator is exercisable:
  // family-inherited (FS_), own build spec (BS_), and unapproved draft (DRAFT_).
  const versionIdSamples = ["FS_Light-Productivity-Tablet_01", "BS_gtk_playground_jjjs_01", "DRAFT_1717000000000"];
  const generated = selectedTests.map((test, index) => ({
    testId: test.id,
    projectId: "gtk_playground",
    phaseId: randomPick(phases),
    buildId: randomPick(builds),
    status: randomPick(["approved", "inWork", "pendingApproval"] as const),
    nextStep: index % 2 === 0 ? ["Yes", "Do special testing for edge cases", "Ensure all test cases are executed"] : ["No"],
    testCategory: randomPick(testCategories),
    testName: test.name,
    testDescription: randomPick(testDescriptionTemplates),
    specType: ["derivedTest"] as ITestSpec["specType"],
    testLocationId: index % 3 === 0 ? "jjjs" : undefined,
    versionId: versionIdSamples[index % versionIdSamples.length],
  }));
  return [baseline, ...generated];
}

const fetch_TestSpec_SpecList: { testList: ITestSpec[] } & Pick<ITestSpecBase, "status" | "nextStep" | "subStatus"> = {
  testList: generateTestSpecList(6),
  status: "inWork",
  subStatus: "needsRevision",
  nextStep: ["Yes", "Do special testing for edge cases", "Ensure all test cases are executed", "Verify test environment setup", "Check for required documentation"],
};
axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSpec_SpecList).reply(200, {
  data: fetch_TestSpec_SpecList,
  message: "Fetch Test List successfully",
});

// Helper function to generate test spec detail from testDefinitions
function generateTestSpecDetail(testIndex = 0): TTestSpecDetail {
  const test = testDefinitions[testIndex];
  const derivedFromTest = testDefinitions[testIndex > 0 ? testIndex - 1 : testDefinitions.length - 1];

  return {
    testId: test.id,
    projectId: "gtk_playground",
    phaseId: randomPick(phases),
    buildId: randomPick(builds),
    status: "inWork",
    specType: ["derivedTest"],
    derivedFrom: {
      key: derivedFromTest.id,
      name: derivedFromTest.name,
      description: "Base test configuration for derived tests",
    },
    nextStep: ["Yes", "Do special testing for edge cases", "Ensure all test cases are executed", "Verify test environment setup", "Check for required documentation"],
    testCategory: randomPick(testCategories),
    testName: test.name,
    testDescription: randomPick(testDescriptionTemplates),
    passCriteria:
      "• No obvious abnormal appearance\n• All labels and logos are correct and clear\n• Gaps and steps should meet specs.\n• Liquid indicators should NOT have changed colors\n• No failure during the product diagnostics test.\n• All functions pass all station check\n• No visible gap between the buttons and the case.\n• No abnormal noise or degradation of feel when pressing the button or plugging or unplugging a USB cord or headphone cord.",
    profiles: [
      {
        filename: "ESD Test- Front.png",
        s3Path: "prod/radar_plus/attachments/eyewear/ansel/hvt/1.0/electrical_esd_air_discharge_test_1/1747990617422/ESD Test- Front.png",
        preSignedURL: "https://example.com/presigned-url-1",
      },
      {
        filename: "ESD Test- Mic and Hinges.png",
        s3Path: "prod/radar_plus/attachments/eyewear/ansel/hvt/1.0/electrical_esd_air_discharge_test_1/1747990617426/ESD Test- Mic and Hinges.png",
        preSignedURL: "https://example.com/presigned-url-2",
      },
    ],
    justifications: [
      {
        filename: "ESD Test- Top.png",
        s3Path: "prod/radar_plus/attachments/eyewear/ansel/hvt/1.0/electrical_esd_air_discharge_test_1/1747990617435/ESD Test- Top.png",
        preSignedURL: "https://example.com/presigned-url-3",
      },
    ],
    approvers: ["jianyihp", "ssdsd"],
  };
}

const fetch_TestSpec_SpecDetail: TTestSpecDetail = generateTestSpecDetail(0);
// Return the deterministic approved baseline when its testId is requested (e2e TC-UI-023), else the
// default derived-test detail. Config carries the request params for GET.
axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSpec_SpecDetail).reply(config => {
  const requestedTestId = config.params?.testId;
  if (requestedTestId === APPROVED_BASELINE_TEST_ID) {
    const detail = {
      ...fetch_TestSpec_SpecDetail,
      testId: APPROVED_BASELINE_TEST_ID,
      testName: "E2E Approved Baseline Test",
      status: "approved",
      specType: [],
      derivedFrom: undefined,
      testDescription: "Deterministic approved baseline for e2e regression coverage.",
    };
    // Echo the served detail so e2e can diff "stored" vs what the edit later sends back —
    // mirrors the BE's isSameSpecControlVersion check (passCriteria/description/justifications).
    (window as unknown as { __lastFetchedTestSpecDetail?: unknown }).__lastFetchedTestSpecDetail = detail;
    return [200, { data: detail }];
  }
  return [200, { data: fetch_TestSpec_SpecDetail }];
});

// ── Test Settings panel (sequences + per-readout mappings) ──────────────
// Two sequences so the picker + lazy per-sequence fetch are exercisable.
axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSpec_Sequences).reply(() => {
  return [200, { code: 200, isSuccess: true, data: ["DEFAULT", "Sequence A"] }];
});

const testSpecReadoutMappings: Record<string, IReadoutMappingItem[]> = {
  DEFAULT: [
    {
      id: 9001,
      keyValuePair: [
        { key: "Voltage", value: "-8kV" },
        { key: "Location", value: "L1" },
      ],
      checks: [
        { id: 1, key: "functional_check", name: "Functional Check", checkCategory: "default" },
        { id: 2, key: "visual_inspection", name: "Visual Inspection", checkCategory: "default,fatp" },
      ],
      measurements: [
        { id: 11, component: "Speaker", name: "Impedance", unit: "Ω" },
        { id: 12, component: "", name: "Frequency Response", unit: "Hz" },
      ],
    },
    {
      id: 9002,
      keyValuePair: [{ key: "Voltage", value: "+8kV" }],
      checks: [{ id: 1, key: "functional_check", name: "Functional Check", checkCategory: "default" }],
      measurements: [{ id: 13, component: "", name: "Leakage Current", unit: "" }],
    },
  ],
  "Sequence A": [
    {
      id: 9101,
      // No KV pairs — exercises the "#<id>" fallback label.
      keyValuePair: [],
      checks: [{ id: 3, key: "esd_check", name: "ESD Check", checkCategory: "esd" }],
      measurements: [],
    },
  ],
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSpec_ReadoutMappings).reply(config => {
  const sequenceId = (config.params?.sequenceId as string) ?? "DEFAULT";
  return [200, { code: 200, isSuccess: true, data: testSpecReadoutMappings[sequenceId] ?? [] }];
});

axiosMockAdapterInstance.onPost(apiConfig.update_TestSpec_SpecDetail).reply(config => {
  // Echo the exact payload the frontend sent so e2e can assert what the UI controls (e.g. TC-UI-023:
  // toggling only Monitor Only must NOT change `status`). The mock is a backend stand-in — it cannot
  // prove the server-side approved→inWork flip; it proves the FE sends status unchanged.
  try {
    const parsed = typeof config.data === "string" ? JSON.parse(config.data) : config.data;
    (window as unknown as { __lastEditTestSpecPayload?: unknown }).__lastEditTestSpecPayload = parsed;
  } catch {
    (window as unknown as { __lastEditTestSpecPayload?: unknown }).__lastEditTestSpecPayload = config.data;
  }
  return [200, { data: { success: true } }];
});

axiosMockAdapterInstance.onPost(apiConfig.create_TestSpec_SpecDetail).reply(200, {
  data: { success: true },
});

// ─── Family Spec mocks (aligned to CR-286038137) ────────────────────────────────
// Summary list: one row per test. `draftVersionId` is set only when an approved row
// AND a separate in-progress draft coexist (fs-1 pending draft, fs-4 rejected draft).
function generateFamilySpecList(): IFamilySpecSummary[] {
  return [
    {
      testId: "test-baseline",
      testCategory: "Baseline",
      testName: "Baseline Test - Lv1",
      status: "approved",
      testDescription: "Visual Inspection per 45/45/10 rule + keyboard dock connector alignment.",
      versionId: "Productivity Tablet-003",
      draftVersionId: "DRAFT_1718870400000",
    },
    { testId: "test-thermal", testCategory: "Environmental", testName: "Thermal Shock Test - Lv1", status: "approved", testDescription: "Rapid -40C to +85C transitions, 200 cycles.", versionId: "Productivity Tablet-001" },
    { testId: "test-drop", testCategory: "Mechanical", testName: "Standard Free Drop Test - Lv1", status: "approved", testDescription: "Drop from 1.2m across six faces + edges, 26 drops.", versionId: "Productivity Tablet-003" },
    { testId: "test-nfc", testCategory: "Functional", testName: "NFC Pairing Test - Lv1", status: "approved", testDescription: "NFC tap-to-pair, 500 cycles.", versionId: "Productivity Tablet-004", draftVersionId: "DRAFT_1718000000000" },
    { testId: "test-wifi", testCategory: "Functional", testName: "WiFi Range Test - Lv1", status: "pendingApproval", testDescription: "WiFi range and throughput test.", versionId: "DRAFT_1717000000000" },
    { testId: "test-bt", testCategory: "Functional", testName: "Bluetooth Pairing Test - Lv1", status: "inWork", subStatus: "needsRevision", testDescription: "BT 5.3 pairing and stability.", versionId: "DRAFT_1716000000000" },
    { testId: "test-hinge", testCategory: "Mechanical", testName: "Hinge Torque Test - Lv1", status: "inWork", subStatus: "notComplete", testDescription: "Hinge torque and durability test.", versionId: "DRAFT_1715000000000" },
  ];
}

axiosMockAdapterInstance.onGet(apiConfig.fetch_FamilySpec_List).reply(200, {
  data: generateFamilySpecList(),
  message: "Fetch Family Spec list successfully",
});

// Detail rows keyed by versionId — approved current, the pending draft, and older approved snapshots.
const familySpecDetailByVersion: Record<string, IFamilySpecDetail> = {
  "Productivity Tablet-003": {
    familyId: "tablet",
    subcategoryId: "tablet-productivity",
    testId: "test-baseline",
    testCategory: "Baseline",
    testName: "Baseline Test - Lv1",
    status: "approved",
    versionId: "Productivity Tablet-003",
    testDescription:
      "Visual Inspection:\n• Verify and document the visual condition before, during, and after tests.\n• Focus on scratches, dents, color mismatch within the 45/45/10 rule.\n• Additional check for keyboard dock connector alignment.",
    passCriteria: "• No visible defects under 45/45/10 rule\n• Liquid ingress indicators intact\n• Keyboard connector pins aligned within 0.1mm tolerance",
    profiles: [],
    justifications: [{ filename: "baseline_v3_justification.pdf", s3Path: "mock/baseline_v3.pdf", preSignedURL: "https://example.com/baseline_v3.pdf" }],
    approvers: [
      { username: "Alice Chen", isCommittee: false },
      { username: "Carol Li", isCommittee: false },
    ],
  },
  DRAFT_1718870400000: {
    familyId: "tablet",
    subcategoryId: "tablet-productivity",
    testId: "test-baseline",
    testCategory: "Baseline",
    testName: "Baseline Test - Lv1",
    status: "pendingApproval",
    versionId: "DRAFT_1718870400000",
    testDescription:
      "Visual Inspection:\n• Verify and document the visual condition before, during, and after tests.\n• Focus on scratches, dents, color mismatch within the 45/45/10 rule.\n• NEW: stylus tip wear inspection and keyboard backlight uniformity check.",
    passCriteria: "• All current criteria\n• Stylus tip wear within 0.2mm\n• Keyboard backlight uniform (< 8% variation)",
    profiles: [],
    justifications: [{ filename: "baseline_v4_justification.pdf", s3Path: "mock/baseline_v4.pdf", preSignedURL: "https://example.com/baseline_v4.pdf" }],
    approvers: [{ username: "Carol Li", isCommittee: false }],
  },
  "Productivity Tablet-002": {
    familyId: "tablet",
    subcategoryId: "tablet-productivity",
    testId: "test-baseline",
    testCategory: "Baseline",
    testName: "Baseline Test - Lv1",
    status: "approved",
    versionId: "Productivity Tablet-002",
    testDescription: "Visual Inspection:\n• Standard 45/45/10 rule inspection.",
    passCriteria: "• No visible defects under 45/45/10 rule",
    profiles: [],
    justifications: [],
    approvers: [{ username: "Bob Wang", isCommittee: false }],
  },
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_FamilySpec_Detail).reply(config => {
  const versionId = config.params?.versionId as string | undefined;
  const detail = (versionId ? familySpecDetailByVersion[versionId] : undefined) ?? familySpecDetailByVersion["Productivity Tablet-003"];
  return [200, { data: detail }];
});

axiosMockAdapterInstance.onGet(apiConfig.fetch_FamilySpec_VersionHistory).reply(200, {
  data: [
    { versionId: "Productivity Tablet-003", summary: "Added keyboard connector check", requestBy: "Alice Chen", approvedAt: "2026-03-15" },
    { versionId: "Productivity Tablet-002", summary: "Revised 45/45/10 rule", requestBy: "Bob Wang", approvedAt: "2025-11-20" },
    { versionId: "Productivity Tablet-001", summary: "Initial approved release", requestBy: "Alice Chen", approvedAt: "2025-06-10" },
  ],
});

axiosMockAdapterInstance.onGet(apiConfig.fetch_FamilySpec_Approvers).reply(200, {
  data: ["Alice Chen", "Bob Wang", "Carol Li", "David Zhang", "Frank Xu"],
});

axiosMockAdapterInstance.onGet(apiConfig.fetch_FamilySpec_Committees).reply(200, {
  data: [
    {
      committeeName: "Tablet Spec Committee",
      members: [
        { username: "Carol Li", isChair: true },
        { username: "Bob Wang", isChair: false },
        { username: "David Zhang", isChair: false },
      ],
    },
  ],
});

axiosMockAdapterInstance.onPost(apiConfig.submit_TestSpec_SignOff).reply(200, { isSuccess: true, data: null });

axiosMockAdapterInstance.onPost(apiConfig.add_FamilySpec).reply(200, { data: { success: true } });
axiosMockAdapterInstance.onPost(apiConfig.edit_FamilySpec).reply(200, { data: { success: true } });
axiosMockAdapterInstance.onPost(apiConfig.discard_FamilySpec).reply(200, { data: { success: true } });

// Generate mock data for TestWaterfall
function generateTestWaterfallMockData(count: number): TDeviceTestWaterfall[] {
  const baseDate = new Date("2025-12-20T00:00:00");
  const data: TDeviceTestWaterfall[] = [];

  // Track counts per build config for sequential numbering
  const configCounts: Record<string, number> = {};

  for (let i = 0; i < count; i++) {
    const buildConfig = randomPick(buildConfigs);
    const family = randomPick(families);
    const project = randomPick(projects);
    const phase = randomPick(phases);
    const build = randomPick(builds);

    // Increment count for this config
    configCounts[buildConfig] = (configCounts[buildConfig] || 0) + 1;
    const configIndex = configCounts[buildConfig];
    const paddedIndex = String(configIndex).padStart(3, "0");

    const shortId = `${buildConfig}_${paddedIndex}`;
    const dsn = `${family.toUpperCase()}_${project.toUpperCase()}_${phase}_${build}_${shortId}`;
    const realDsn = `GN44C7${generateHexString(10)}`;

    const device: TDeviceTestWaterfall = {
      dsn,
      shortId,
      realDsn,
      buildConfig,
      familyId: family,
      projectId: project,
      phaseId: phase,
      buildId: build,
      testList: generateTestList(baseDate),
    };

    data.push(device);
  }

  // Add one device with a test missing dates to exercise the ⚠ indicator
  return [
    {
      dsn: "AUCC_BRIOCHE_DVT_1-DOT-0_BFD-1_001",
      shortId: "BFD-1_001",
      realDsn: "GN44C7MISSING001",
      buildConfig: "BFD-1",
      familyId: "aucc",
      projectId: "brioche",
      phaseId: "dvt",
      buildId: "1.0",
      testList: [
        // { testId: "spill_test_1", testName: "Spill Test - L1", sequence: "S1", status: "ongoing", startDate: "2025-12-20T08:00:00", endDate: "2025-12-22T12:00:00", duration: 2, order: 1, issueList: [] },
        // { testId: "drop_test_1", testName: "Standard Free Drop Test", sequence: "S1", status: "notStarted", startDate: "", endDate: "", duration: 3, order: 2, issueList: [] },
        {
          actualEndDate: "2026-07-31",
          actualStartDate: "2026-07-31",
          duration: 7,
          endDate: "2026-08-10",
          isPassed: true,
          order: 1,
          sequence: "DEFAULT",
          startDate: "2026-08-03",
          status: "pass",
          substatus: "COMPLETE",
          testId: "baseline_baseline_check_test_1",
          testName: "Baseline Check Test - L1",
        },
        {
          actualEndDate: "2026-07-31",
          actualStartDate: "2026-07-31",
          duration: 7,
          endDate: "2026-08-10",
          isPassed: true,
          order: 2,
          sequence: "DEFAULT",
          startDate: "2026-08-03",
          status: "pass",
          substatus: "COMPLETE",
          testId: "baseline_baseline_check_test_2",
          testName: "Baseline Check Test - L2",
        },
        {
          actualEndDate: "2026-07-31",
          actualStartDate: "2026-07-31",
          duration: 7,
          endDate: "2026-08-10",
          isPassed: true,
          order: 3,
          sequence: "DEFAULT",
          startDate: "2026-08-03",
          status: "pass",
          substatus: "COMPLETE",
          testId: "baseline_baseline_check_test_3",
          testName: "Baseline Check Test - L3",
        },
        {
          actualEndDate: "2026-08-01",
          actualStartDate: "2026-07-31",
          duration: 7,
          endDate: "2026-08-10",
          isPassed: true,
          order: 4,
          sequence: "DEFAULT",
          startDate: "2026-08-03",
          status: "pass",
          substatus: "COMPLETE",
          testId: "baseline_baseline_check_test_4",
          testName: "Baseline Check Test - L4",
        },
      ] as any,
    },
  ];

  // return data;
}

// Generate 300 mock entries for TestWaterfall

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestWaterfall_List).reply(200, {
  data: generateTestWaterfallMockData(500),
});

// TestWaterfall Config mock data
import { TBuildConfigItem } from "@/type/axios";

const fetch_Config_List: TBuildConfigItem[] = [
  {
    key: "h-doe1",
    name: "H-DOE1",
    allocation: 40,
    assigned: 7,
  },
  {
    key: "h-doe1-1",
    name: "Config1-1",
    allocation: 15,
    assigned: 5,
  },
  {
    key: "h-doe2",
    name: "H-DOE2",
    allocation: 30,
    assigned: 0,
  },
  {
    key: "config2-1",
    name: "Config2-1",
    allocation: 30,
    assigned: 12,
  },
  {
    key: "config2-2",
    name: "Config2-2",
    allocation: 30,
    assigned: 8,
  },
  {
    key: "config3",
    name: "Config3",
    allocation: 60,
    assigned: 25,
  },
  {
    key: "config4",
    name: "Config4",
    allocation: 60,
    assigned: 30,
  },
  {
    key: "config5-1",
    name: "Config5-1",
    allocation: 30,
    assigned: 15,
  },
  {
    key: "config5-2",
    name: "Config5-2",
    allocation: 10,
    assigned: 5,
  },
  {
    key: "config6",
    name: "Config6",
    allocation: 40,
    assigned: 20,
  },
  {
    key: "hf1",
    name: "HF1",
    allocation: 25,
    assigned: 10,
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_Config_List).reply(200, {
  data: fetch_Config_List,
});

// Mock handlers for TestWaterfall write operations
axiosMockAdapterInstance.onPost(apiConfig.update_TestWaterfall_DSNTest).reply(200, {
  data: { success: true },
  message: "Test waterfall updated successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.update_TestWaterfall_Config).reply(config => {
  const requestData = JSON.parse(config.data);
  const allocation: TBuildConfigItem[] = requestData.allocation ?? [];
  // Validate allocation
  const hasInvalidAllocation = allocation.some(item => (item.allocation ?? 0) < (item.assigned ?? 0));

  if (hasInvalidAllocation) {
    return [
      400,
      {
        success: false,
        message: "Allocation cannot be less than assigned devices",
      },
    ];
  }

  // Honor the rename contract: an item carrying `newKey` renames an existing
  // config in place (match on the original `key`), rather than adding a new one.
  allocation.forEach(item => {
    if (item.newKey) {
      const existing = fetch_Config_List.find(c => c.key === item.key);
      if (existing) {
        existing.key = item.newKey;
      }
    }
  });

  return [
    200,
    {
      data: { success: true },
      message: "Build configuration updated successfully",
    },
  ];
});

axiosMockAdapterInstance.onPost(apiConfig.copy_TestWaterfall_List).reply(200, {
  data: { success: true, affectedDevices: 7 },
  message: "Waterfall copied successfully",
});

const fetch_TestWaterfall_TimelineOverview: TTestWaterfallConfidence = {
  confidence: 0.85,
  dataPoints: [
    {
      date: "2025-12-20",
      description: "Baseline Testing Phase",
      predictedCompletion: 0.2,
      // actualCompletion: 0.18,
    },
    {
      date: "2025-12-21",
      description: "Environmental Testing ?",
      predictedCompletion: 0.35,
      actualCompletion: 0.32,
    },
    {
      date: "2025-12-23",
      description: "Mid-Phase Checkpoint",
      predictedCompletion: 0.6,
      actualCompletion: 0.55,
    },
    {
      date: "2025-12-25",
      description: "Final Testing Phase",
      predictedCompletion: 0.85,
      actualCompletion: 0.78,
    },
    {
      date: "2026-02-1",
      description: "Completion Target",
      predictedCompletion: 1.0,
      actualCompletion: 0.92,
    },
    {
      date: "2026-01-29",
      description: "Today",
      predictedCompletion: 1.0,
      actualCompletion: 0.92,
    },
  ],
  scheduleCompleteness: {
    rate: 0.95,
    issueList: [],
  },
  scheduleCompliance: {
    rate: 0.88,
    issueList: [
      "Overlap: [TABLET_TUNGSTEN_DVT_1.0_H-DOE1_001] Operational Corner Test End Date(2025-12-23) | Standard Free Drop Test Start Date(2025-12-23)",
      "Overlap: [TABLET_TUNGSTEN_DVT_1.0_H-DOE1_002] Operational Corner Test End Date(2025-12-23) | Standard Free Drop Test Start Date(2025-12-23)",
    ],
  },
  resourceCompliance: {
    rate: 0.92,
    issueList: ["Conflict: [H-DOE1] 1.2 occupied on 2025-12-21", "Conflict: [Temperature Chamber A] 1.5 occupied on 2025-12-22"],
  },
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestWaterfall_TimelineOverview).reply(200, {
  data: fetch_TestWaterfall_TimelineOverview,
});

// TestWaterfall Timeline Validation mock handler
// This simulates both success and failure scenarios
axiosMockAdapterInstance.onPost(apiConfig.validate_TestWaterfall_Timeline).reply(() => {
  // Simulate validation logic - 80% success rate for demo purposes
  const shouldFail = Math.random() < 0.2;

  if (shouldFail) {
    return [
      400,
      {
        isSuccess: false,
        code: 400,
        message:
          "'H-DOE1' is over-capacity due to: TABLET_TUNGSTEN_DVT_1.0_H-DOE1_001, TABLET_TUNGSTEN_DVT_1.0_H-DOE1_002\n\nSUGGESTIONS: \n\nFor the over-capacity DSNs, clean all dates except the baseline starting dates and save. This will trigger another round of auto-generating.",
      },
    ];
  }

  return [
    200,
    {
      isSuccess: true,
      code: 200,
      message: "Timeline validation completed successfully",
    },
  ];
});

// TestWaterfall Save Execution Timeline mock handler
axiosMockAdapterInstance.onPost(apiConfig.save_TestWaterfall_ExecutionTimeline).reply(200, {
  isSuccess: true,
  code: 200,
  message: "Execution timeline saved to cache successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.reset_TestSpec_SpecDetail).reply(200, {
  isSuccess: true,
  code: 200,
  message: "reset_TestSpec_SpecDetail",
});

// Task Center mock data
import { ITaskCenterProjectRaw } from "@/type/axios";

const fetch_TaskCenter_Projects: ITaskCenterProjectRaw[] = [
  {
    buildIdentifierIds: "eyewear|tungsten|goertek|dvt|1.0",
    buildIdentifierNames: "Eyewear|Tungsten|GoerTek|DVT|1.0",
    realDsnCompleted: 158,
    realDsnTotal: 672,
    testInputsCompleted: 214,
    testInputsTotal: 1735,
    testsDueSoon: [
      { testCode: "mechanical_ball_impact_1", testNameAndLevel: "Ball Impact - L1", date: "2025-12-10" },
      { testCode: "mechanical_standard_free_drop_test_1", testNameAndLevel: "Standard Free Drop Test - L1", date: "2025-12-10" },
      { testCode: "cosmetic_solar_exposure_test_1", testNameAndLevel: "Solar Exposure Test - L1", date: "2025-12-12" },
    ],
  },
  {
    buildIdentifierIds: "eyewear|spinel|goertek|hvt|1.0",
    buildIdentifierNames: "Eyewear|Spinel|GoerTek|HVT|1.0",
    realDsnCompleted: 150,
    realDsnTotal: 672,
    testInputsCompleted: 214,
    testInputsTotal: 1735,
    testsDueSoon: [
      { testCode: "mechanical_ball_impact_1", testNameAndLevel: "Ball Impact - L1", date: "2025-12-10" },
      { testCode: "mechanical_operational_corner_test_1", testNameAndLevel: "Operational Corner Test - Lv1", date: "2025-12-12" },
    ],
  },
  {
    buildIdentifierIds: "eyewear|roselite|goertek|pvt|1.0",
    buildIdentifierNames: "Eyewear|Roselite|GoerTek|PVT|1.0",
    realDsnCompleted: 158,
    realDsnTotal: 672,
    testInputsCompleted: 214,
    testInputsTotal: 1735,
    testsDueSoon: [],
  },
  {
    buildIdentifierIds: "eyewear|tungsten|goertek|dvt|2.0",
    buildIdentifierNames: "Eyewear|Tungsten|GoerTek|DVT|2.0",
    realDsnCompleted: 158,
    realDsnTotal: 672,
    testInputsCompleted: 214,
    testInputsTotal: 1735,
    testsDueSoon: [{ testCode: "mechanical_ball_impact_1", testNameAndLevel: "Ball Impact - L1", date: "2025-12-10" }],
  },
  {
    buildIdentifierIds: "eyewear|spinel|goertek|hvt|2.0",
    buildIdentifierNames: "Eyewear|Spinel|GoerTek|HVT|2.0",
    realDsnCompleted: 150,
    realDsnTotal: 672,
    testInputsCompleted: 214,
    testInputsTotal: 1735,
    testsDueSoon: [{ testCode: "mechanical_standard_free_drop_test_1", testNameAndLevel: "Standard Free Drop Test - L1", date: "2025-12-10" }],
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_TaskCenter_Projects).reply(200, {
  data: fetch_TaskCenter_Projects,
});
// TestWaterfall Holidays (Non-working Days) mock data
// Simulate weekends and holidays for July 2025
const fetch_TestWaterfall_Holidays: string[] = [
  // July 2025 weekends (Saturdays and Sundays)
  "2025-07-05",
  "2025-07-06",
  "2025-07-12",
  "2025-07-13",
  "2025-07-19",
  "2025-07-20",
  "2025-07-26",
  "2025-07-27",
  // Some additional holidays
  "2025-01-01", // New Year's Day
  "2025-07-04", // Independence Day (US)
  "2025-12-25", // Christmas
  "2025-12-31", // New Year's Eve
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestWaterfall_Holidays).reply(200, {
  isSuccess: true,
  code: 200,
  data: fetch_TestWaterfall_Holidays,
});

axiosMockAdapterInstance.onPost(apiConfig.update_TestWaterfall_Holidays).reply(200, {
  isSuccess: true,
  code: 200,
  message: "Holidays updated successfully",
});

// Real DSN mock data

const fetch_RealDSN_List: IRealDSNItem[] = [
  {
    id: "1",
    dsn: "D1F-Buzze1_001",
    shortId: "Buzze1_001",
    realDsn: "GN42HE01315700AV",
    receivedDate: "2025-09-21",
    buildConfig: "Tungsten-DVT-1.0",
    isEditable: false,
  },
  {
    id: "2",
    dsn: "D1F-Buzze1_002",
    shortId: "Buzze1_002",
    realDsn: "GN42HE01315700B8",
    receivedDate: "2025-09-21",
    buildConfig: "Tungsten-DVT-1.0",
    isEditable: false,
  },
  {
    id: "3",
    dsn: "D1F-Buzze1_003",
    shortId: "Buzze1_003",
    realDsn: "",
    receivedDate: "",
    buildConfig: "Tungsten-DVT-1.0",
    isEditable: true,
  },
  {
    id: "4",
    dsn: "D1F-Buzze1_004",
    shortId: "Buzze1_004",
    realDsn: "",
    receivedDate: "",
    buildConfig: "Tungsten-DVT-1.0",
    isEditable: true,
  },
  {
    id: "5",
    dsn: "D1F-Buzze2_001",
    shortId: "Buzze2_001",
    realDsn: "",
    receivedDate: "",
    buildConfig: "Tungsten-DVT-1.0",
    isEditable: true,
  },
  {
    id: "6",
    dsn: "D1F-Buzze2_002",
    shortId: "Buzze2_002",
    realDsn: "",
    receivedDate: "",
    buildConfig: "Tungsten-DVT-1.0",
    isEditable: true,
  },
  {
    id: "7",
    dsn: "D1F-Buzze2_003",
    shortId: "Buzze2_003",
    realDsn: "",
    receivedDate: "",
    buildConfig: "Tungsten-DVT-1.0",
    isEditable: true,
  },
  {
    id: "8",
    dsn: "D1F-Buzze2_004",
    shortId: "Buzze2_004",
    realDsn: "",
    receivedDate: "",
    buildConfig: "Tungsten-DVT-1.0",
    isEditable: true,
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_RealDSN_List).reply(200, {
  data: fetch_RealDSN_List,
});

axiosMockAdapterInstance.onPost(apiConfig.update_RealDSN_Item).reply(200, {
  data: { success: true },
  message: "Real DSN item updated successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.delete_RealDSN_Item).reply(200, {
  data: { success: true },
  message: "Real DSN item deleted successfully",
});

axiosMockAdapterInstance.onGet(apiConfig.download_RealDSN_Template).reply(200, new Blob());

axiosMockAdapterInstance.onPost(apiConfig.upload_RealDSN_BulkData).reply(() => {
  // Simulate three scenarios - ~33% chance of each
  const rand = Math.random();
  const hasErrors = rand < 0.33;
  const noChanges = rand < 0.66;

  if (hasErrors) {
    return [
      200,
      {
        isSuccess: true,
        data: {
          changes: [
            {
              dsn: "D1F-Buzze1_001",
              hasRealDsnConflict: false,
              isEditable: false,
              isStringFormatValid: true,
              message: "DSN is not editable and cannot be updated",
              newRealDsn: "GN42HE01315700AV",
              newReceivedDate: "2025-09-21",
              oldRealDsn: "GN42HE01315700AV",
              oldReceivedDate: "2025-09-21",
            },
            {
              dsn: "D1F-Buzze1_003",
              hasRealDsnConflict: true,
              isEditable: true,
              isStringFormatValid: true,
              message: "Duplicate realDsn 'GN42HE01315700C1' in 2 rows in this file",
              newRealDsn: "GN42HE01315700C1",
              newReceivedDate: "2025-09-22",
              oldRealDsn: "",
              oldReceivedDate: "",
            },
            {
              dsn: "D1F-Buzze1_004",
              hasRealDsnConflict: true,
              isEditable: true,
              isStringFormatValid: true,
              message: "Duplicate realDsn 'GN42HE01315700C1' in 2 rows in this file",
              newRealDsn: "GN42HE01315700C1",
              newReceivedDate: "2025-09-22",
              oldRealDsn: "",
              oldReceivedDate: "",
            },
          ],
          code: 200,
          isSuccess: true,
          message: "Upload failed: 3 entries contain errors. Please fix and re-upload.",
          updateToDatabase: false,
        } as IBulkUploadResult,
        message: "Upload failed: 3 entries contain errors. Please fix and re-upload.",
      },
    ];
  }

  if (noChanges) {
    return [
      200,
      {
        isSuccess: true,
        data: {
          changes: [],
          code: 200,
          isSuccess: true,
          message: "No changes detected in the uploaded file",
          updateToDatabase: false,
        } as IBulkUploadResult,
        message: "No changes detected in the uploaded file",
      },
    ];
  }

  return [
    200,
    {
      isSuccess: true,
      data: {
        changes: [
          {
            dsn: "D1F-Buzze1_003",
            isEditable: true,
            isStringFormatValid: true,
            message: "Change is valid and can be applied",
            newRealDsn: "GN42HE01315700C1",
            newReceivedDate: "2025-09-22",
            oldRealDsn: "",
            oldReceivedDate: "",
          },
          {
            dsn: "D1F-Buzze1_004",
            isEditable: true,
            isStringFormatValid: true,
            message: "Change is valid and can be applied",
            newRealDsn: "GN42HE01315700C2",
            newReceivedDate: "2025-09-22",
            oldRealDsn: "",
            oldReceivedDate: "",
          },
        ],
        code: 200,
        isSuccess: true,
        message: "Successfully updated 2 entries to database",
        updateToDatabase: true,
      } as IBulkUploadResult,
      message: "Successfully updated 2 entries to database",
    },
  ];
});

// ── Import Waterfall mocks ───────────────────────────────────────────────────
axiosMockAdapterInstance.onGet(apiConfig.download_TestWaterfall_Template).reply(200, new Blob());
axiosMockAdapterInstance.onGet(apiConfig.download_ReadoutData).reply(200, new Blob());

axiosMockAdapterInstance.onPost(apiConfig.import_TestWaterfall).reply(() => {
  // Cycle through three scenarios so all Step-3 states are reachable in dev.
  const rand = Math.random();
  const scenario = rand < 0.34 ? "errors" : rand < 0.67 ? "empty" : "success";

  if (scenario === "empty") {
    return [200, { isSuccess: true, code: 200, message: "OK", data: { changes: [], updateToDatabase: false } }];
  }

  const successChanges: IWaterfallImportChange[] = [
    {
      dsn: "D1F-Buzze1_001",
      shortId: "SID-001",
      testId: "T-100",
      testName: "Vibration",
      sequence: "SEQ-1",
      oldOrder: 0,
      newOrder: 3,
      changeType: "ADD",
      isValid: true,
      isEditable: true,
      hasDuplicateSequence: false,
      message: "Added to plan",
    },
    {
      dsn: "D1F-Buzze1_002",
      shortId: "SID-002",
      testId: "T-101",
      testName: "Thermal",
      sequence: "SEQ-2",
      oldOrder: 2,
      newOrder: 5,
      changeType: "MOVE",
      isValid: true,
      isEditable: true,
      hasDuplicateSequence: false,
      message: "Reordered",
    },
    {
      dsn: "D1F-Buzze1_003",
      shortId: "SID-003",
      testId: "T-102",
      testName: "Drop",
      sequence: "SEQ-3",
      oldOrder: 4,
      newOrder: 0,
      changeType: "REMOVE",
      isValid: true,
      isEditable: true,
      hasDuplicateSequence: false,
      message: "Removed from plan",
    },
    {
      dsn: "D1F-Buzze1_004",
      shortId: "SID-004",
      testId: "T-103",
      testName: "ESD",
      sequence: "SEQ-4",
      oldOrder: 1,
      newOrder: 1,
      changeType: "UNCHANGED",
      isValid: true,
      isEditable: true,
      hasDuplicateSequence: false,
      message: "",
    },
  ];

  if (scenario === "success") {
    return [200, { isSuccess: true, code: 200, message: "OK", data: { changes: successChanges, updateToDatabase: true } }];
  }

  // errors scenario: two invalid rows mixed with valid ones; not committed.
  const errorChanges: IWaterfallImportChange[] = [
    ...successChanges.slice(0, 2),
    {
      dsn: "D1F-Buzze1_005",
      shortId: "SID-005",
      testId: "T-104",
      testName: "Bend",
      sequence: "SEQ-2",
      oldOrder: 0,
      newOrder: 2,
      changeType: "ADD",
      isValid: false,
      isEditable: true,
      hasDuplicateSequence: true,
      message: "Duplicate sequence 'SEQ-2' in 2 rows in this file",
    },
    {
      dsn: "D1F-Buzze1_006",
      shortId: "SID-006",
      testId: "T-105",
      testName: "Locked",
      sequence: "SEQ-6",
      oldOrder: 3,
      newOrder: 4,
      changeType: "MOVE",
      isValid: false,
      isEditable: false,
      hasDuplicateSequence: false,
      message: "Test is not editable and cannot be moved",
    },
  ];
  return [200, { isSuccess: true, code: 200, message: "OK", data: { changes: errorChanges, updateToDatabase: false } }];
});

// Test Status mock data

const testStatusIssues: TTestStatusIssue[] = [
  { issueId: "#3214", type: "failure", description: "CTF fail", failureCount: 8, changedCount: 2 },
  { issueId: "#3215", type: "observation", description: "fail", failureCount: 4, changedCount: -1 },
  { issueId: "#3216", type: "failure", description: "", failureCount: 2, changedCount: 0 },
  { issueId: "#3217", type: "failure", description: "detected in 3 units", failureCount: 3, changedCount: 1 },
  { issueId: "#3218", type: "observation", description: "Abnormal drain observed", failureCount: 5, changedCount: -2 },
  { issueId: "#3219", type: "failure", description: "Unresponsive area", failureCount: 6, changedCount: 3 },
  { issueId: "#3220", type: "observation", description: "Signal drops intermittently", failureCount: 2, changedCount: 0 },
];

function generateTestStatusMockData(): ITestStatusItem[] {
  const testNames = [
    { id: "baseline_check_lv1", name: "Baseline Check Test - Lv1" },
    { id: "cold_storage_lv1", name: "Cold Storage Test - Lv1" },
    { id: "condensation_lv1", name: "Condensation Test - Lv1" },
    { id: "dashboard_lv1", name: "Dashboard Test - Lv1" },
    { id: "thermal_cycling_lv1", name: "Thermal Cycling Test - Lv1" },
    { id: "random_vibration_lv1", name: "Random Vibration Test - Lv1" },
    { id: "drop_test_lv1", name: "Drop Test - Lv1" },
    { id: "water_resistance_lv1", name: "Water Resistance Test - Lv1" },
  ];

  return testNames.map((test, index) => {
    // Generate realistic completion data
    const total = Math.floor(Math.random() * 100) + 10;
    const complete = Math.floor(Math.random() * total * 0.8);
    const ongoing = Math.floor(Math.random() * (total - complete) * 0.5);
    const cancel = Math.floor(Math.random() * 3);
    const plan = total - complete - ongoing - cancel;
    const completionRate = (complete / total) * 100;

    // Generate failure data
    const totalTests = Math.floor(Math.random() * 150) + 10;
    const failureCount = index === 2 ? 11 : Math.floor(Math.random() * totalTests * 0.2);

    // Generate issues for tests with failures
    let issues: TTestStatusIssue[] = [];
    if (failureCount > 0 && index < 4) {
      const numIssues = Math.min(failureCount, Math.floor(Math.random() * 4) + 1);
      issues = testStatusIssues.slice(0, numIssues).map(issue => ({
        ...issue,
        issueId: `#${3214 + index * 10 + Math.floor(Math.random() * 10)}`,
        failureCount: Math.floor(Math.random() * 10) + 1,
        changedCount: Math.floor(Math.random() * 7) - 3, // Random value between -3 and 3
      }));
    }

    // Generate ETC date (future date within next few months)
    const etcDate = new Date();
    etcDate.setDate(etcDate.getDate() + Math.floor(Math.random() * 60) + 30);
    const etc = etcDate.toISOString().split("T")[0];

    return {
      testId: test.id,
      testName: test.name,
      completion: {
        plan,
        cancel,
        ongoing,
        complete,
      },
      completionRate: parseFloat(completionRate.toFixed(1)),
      failureCount,
      totalCount: totalTests,
      etc,
      issues,
    };
  });
}

const fetch_TestStatus_List: ITestStatusItem[] = generateTestStatusMockData();

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestStatus_List).reply(200, {
  data: fetch_TestStatus_List,
  message: "Test status list fetched successfully",
});

// ── FDDD (Failure Data Deep Dive) Mock Data ───────────────────────────

import { IFDDDCascadingFilterResponse, IFDDDDimensionOption, IFDDDFailureRateNode, IIdentifierTreeNode, IPresetItem } from "@/type/axios";

// ── Helper: generate large dimension option arrays for stress-testing ──
function generateDimensionOptions(prefix: string, count: number, matchedField?: string): IFDDDDimensionOption[] {
  const adjectives = ["Advanced", "Basic", "Critical", "Dynamic", "Enhanced", "Functional", "General", "High-Res", "Integrated", "Joint"];
  const nouns = ["Module", "Sensor", "Controller", "Assembly", "Board", "Connector", "Panel", "Switch", "Relay", "Interface"];
  const suffixes = ["Alpha", "Beta", "Gamma", "Delta", "Rev-A", "Rev-B", "Rev-C", "MK-I", "MK-II", "MK-III"];
  return Array.from({ length: count }, (_, i) => {
    const adj = adjectives[i % adjectives.length];
    const noun = nouns[Math.floor(i / adjectives.length) % nouns.length];
    const sfx = suffixes[Math.floor(i / (adjectives.length * nouns.length)) % suffixes.length];
    const opt: IFDDDDimensionOption = {
      id: `${prefix}${String(i + 1).padStart(4, "0")}`,
      name: `${adj} ${noun} ${sfx} #${i + 1}`,
    };
    if (matchedField) opt.matchedField = matchedField;
    return opt;
  });
}

const fdddProjects: IFDDDDimensionOption[] = [
  { id: "P001", name: "Palomo" },
  { id: "P002", name: "Pisco" },
  { id: "P003", name: "Seabreeze" },
  { id: "P004", name: "Rossini" },
];

const fdddPhaseBuilds: IFDDDDimensionOption[] = [
  { id: "HVT-1.0", name: "HVT-1.0" },
  { id: "EVT-1.0", name: "EVT-1.0" },
  { id: "EVT-1.1", name: "EVT-1.1" },
  { id: "DVT-1.0", name: "DVT-1.0" },
];

// ── Scaled-up dimension options to stress-test FE rendering ──
const fdddConfigs: IFDDDDimensionOption[] = generateDimensionOptions("C", 500, "config_name");
const fdddTests: IFDDDDimensionOption[] = generateDimensionOptions("T", 300, "test_name");
const fdddTestSequences: IFDDDDimensionOption[] = generateDimensionOptions("TS", 200, "grouping_sequence");
const fdddReadouts: IFDDDDimensionOption[] = generateDimensionOptions("R", 200, "order");
const fdddIssues: IFDDDDimensionOption[] = generateDimensionOptions("ISS", 500, "failure_mode");
const fdddDevices: IFDDDDimensionOption[] = generateDimensionOptions("D", 2000, "dsn");
const fdddCmLocations: IFDDDDimensionOption[] = generateDimensionOptions("L", 50, "name");

// ── IDENTIFIER_TREE mock data ── 5-level tree: Family → Project → Location → Phase → Build
// Mirrors fetch_Project_List structure but uses IIdentifierTreeNode (id/name) and adds Phase→Build children
const fdddIdentifierTree: IIdentifierTreeNode[] = [
  {
    key: "piezo",
    name: "Piezo",
    children: [
      {
        key: "gtk_playground",
        name: "GTK Playground",
        children: [
          {
            key: "shenzhen",
            name: "Shenzhen",
            children: [
              {
                key: "DVT",
                name: "DVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "1.1", name: "1.1" },
                  { key: "2.0", name: "2.0" },
                ],
              },
              {
                key: "EVT",
                name: "EVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
              { key: "HVT", name: "HVT", children: [{ key: "1.0", name: "1.0" }] },
            ],
          },
          {
            key: "taipei",
            name: "Taipei",
            children: [
              {
                key: "DVT",
                name: "DVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
              { key: "PVT", name: "PVT", children: [{ key: "1.0", name: "1.0" }] },
            ],
          },
          {
            key: "seattle",
            name: "Seattle",
            children: [
              {
                key: "EVT",
                name: "EVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "1.1", name: "1.1" },
                ],
              },
            ],
          },
        ],
      },
      {
        key: "baklava_packaging",
        name: "Baklava Packaging",
        children: [
          {
            key: "shenzhen",
            name: "Shenzhen",
            children: [
              { key: "DVT", name: "DVT", children: [{ key: "1.0", name: "1.0" }] },
              {
                key: "EVT",
                name: "EVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
            ],
          },
          {
            key: "dongguan",
            name: "Dongguan",
            children: [
              {
                key: "HVT",
                name: "HVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
            ],
          },
        ],
      },
      {
        key: "cypress",
        name: "Cypress",
        children: [
          {
            key: "shenzhen",
            name: "Shenzhen",
            children: [{ key: "DVT", name: "DVT", children: [{ key: "1.0", name: "1.0" }] }],
          },
          {
            key: "taipei",
            name: "Taipei",
            children: [
              { key: "EVT", name: "EVT", children: [{ key: "1.0", name: "1.0" }] },
              {
                key: "PVT",
                name: "PVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: "athena",
    name: "Athena",
    children: [
      {
        key: "laser",
        name: "Laser",
        children: [
          {
            key: "shenzhen",
            name: "Shenzhen",
            children: [
              {
                key: "DVT",
                name: "DVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
              { key: "EVT", name: "EVT", children: [{ key: "1.0", name: "1.0" }] },
            ],
          },
          {
            key: "taipei",
            name: "Taipei",
            children: [{ key: "HVT", name: "HVT", children: [{ key: "1.0", name: "1.0" }] }],
          },
        ],
      },
      {
        key: "crown",
        name: "Crown",
        children: [
          {
            key: "dongguan",
            name: "Dongguan",
            children: [
              { key: "DVT", name: "DVT", children: [{ key: "1.0", name: "1.0" }] },
              {
                key: "PVT",
                name: "PVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
            ],
          },
          {
            key: "seattle",
            name: "Seattle",
            children: [
              {
                key: "EVT",
                name: "EVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "1.1", name: "1.1" },
                ],
              },
            ],
          },
        ],
      },
      {
        key: "croissant",
        name: "Croissant",
        children: [
          {
            key: "shenzhen",
            name: "Shenzhen",
            children: [
              {
                key: "DVT",
                name: "DVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                  { key: "3.0", name: "3.0" },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: "theia",
    name: "Theia",
    children: [
      {
        key: "crumpet_donut",
        name: "Crumpet Donut",
        children: [
          {
            key: "shenzhen",
            name: "Shenzhen",
            children: [
              { key: "DVT", name: "DVT", children: [{ key: "1.0", name: "1.0" }] },
              {
                key: "HVT",
                name: "HVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
            ],
          },
          {
            key: "taipei",
            name: "Taipei",
            children: [{ key: "EVT", name: "EVT", children: [{ key: "1.0", name: "1.0" }] }],
          },
        ],
      },
      {
        key: "octave",
        name: "Octave",
        children: [
          {
            key: "seattle",
            name: "Seattle",
            children: [
              {
                key: "DVT",
                name: "DVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
              { key: "PVT", name: "PVT", children: [{ key: "1.0", name: "1.0" }] },
            ],
          },
        ],
      },
    ],
  },
  {
    key: "cupcake",
    name: "Cupcake",
    children: [
      {
        key: "blink_indoor_camera",
        name: "Blink Indoor Camera",
        children: [
          {
            key: "shenzhen",
            name: "Shenzhen",
            children: [
              { key: "DVT", name: "DVT", children: [{ key: "1.0", name: "1.0" }] },
              {
                key: "EVT",
                name: "EVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
            ],
          },
          {
            key: "dongguan",
            name: "Dongguan",
            children: [{ key: "HVT", name: "HVT", children: [{ key: "1.0", name: "1.0" }] }],
          },
          {
            key: "seattle",
            name: "Seattle",
            children: [
              {
                key: "PVT",
                name: "PVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "2.0", name: "2.0" },
                ],
              },
            ],
          },
        ],
      },
      {
        key: "donut",
        name: "Donut",
        children: [
          {
            key: "taipei",
            name: "Taipei",
            children: [
              {
                key: "DVT",
                name: "DVT",
                children: [
                  { key: "1.0", name: "1.0" },
                  { key: "1.1", name: "1.1" },
                ],
              },
              { key: "EVT", name: "EVT", children: [{ key: "1.0", name: "1.0" }] },
            ],
          },
        ],
      },
    ],
  },
];

// Full dimension options map for mock - keyed by "{dimensionKey}Options"
const fdddAllDimensionOptions: Record<string, IFDDDDimensionOption[]> = {
  projectOptions: fdddProjects,
  phaseBuildOptions: fdddPhaseBuilds,
  cmLocationOptions: fdddCmLocations,
  configOptions: fdddConfigs,
  buildMatrixOptions: [],
  deviceOptions: fdddDevices,
  testOptions: fdddTests,
  testSequenceOptions: fdddTestSequences,
  readoutOptions: fdddReadouts,
  testVariableOptions: [],
  issueOptions: fdddIssues,
  failedPartOptions: generateDimensionOptions("FP", 300, "failing_component"),
  recoveryTypeOptions: generateDimensionOptions("RT", 100, "recovery_steps"),
  issueSeverityOptions: generateDimensionOptions("SEV", 50),
  failureCategoryOptions: generateDimensionOptions("FC", 100, "category"),
};

axiosMockAdapterInstance.onPost(apiConfig.fetch_FDDD_CascadingFilterOptions).reply(config => {
  const body = config.data ? JSON.parse(config.data) : {};
  const dimensionTypes: string[] | undefined = body.dimensionTypes;

  // Build response: only include requested dimension options (or all if not specified)
  const responseOptions: Record<string, IFDDDDimensionOption[]> = {};
  if (dimensionTypes && dimensionTypes.length > 0) {
    // Only return options for the requested dimension types
    for (const dimKey of dimensionTypes) {
      const optionsKey = `${dimKey}Options`;
      if (optionsKey in fdddAllDimensionOptions) {
        responseOptions[optionsKey] = fdddAllDimensionOptions[optionsKey];
      }
    }
  } else {
    // No dimensionTypes specified — return all (backwards compatible)
    Object.assign(responseOptions, fdddAllDimensionOptions);
  }

  // Include identifierTreeOptions when IDENTIFIER_TREE is requested
  const includeTree = dimensionTypes?.includes("IDENTIFIER_TREE");

  const response: IFDDDCascadingFilterResponse = {
    ...fdddAllDimensionOptions,
    ...responseOptions,
    issueFoundDateRange: { minDate: "2026-03-01", maxDate: "2026-04-01" },
    ...(includeTree ? { identifierTreeOptions: fdddIdentifierTree } : {}),
  } as IFDDDCascadingFilterResponse;

  return [200, { data: response, isSuccess: true }];
});

// Failure Rate Summary mock — generates realistic hierarchical tree based on requested path

/** Dimension-specific mock data pools for realistic names */
const failureRateMockPools: Record<string, { id: string; name: string }[]> = {
  test: [
    { id: "ball_impact_front_lv1", name: "Ball Impact Front Side Test - Lv1" },
    { id: "baseline_check_lv1", name: "Baseline Check Test - Lv1" },
    { id: "thermal_cycling_lv1", name: "Thermal Cycling Test - Lv1" },
    { id: "random_vibration_lv1", name: "Random Vibration Test - Lv1" },
    { id: "free_drop_gn_lv1", name: "Standard Free Drop Test - GN - Lv1" },
    { id: "temp_humidity_lv1", name: "Temperature and Humidity Cycling Test - Lv1" },
    { id: "water_immersion_lv1", name: "Water Immersion Test - Lv1" },
    { id: "esd_air_discharge_lv1", name: "ESD Air Discharge Test - Lv1" },
  ],
  issue: [
    { id: "2534", name: "Issue2534: TFT - Crack" },
    { id: "2533", name: "Issue2533: CG - Crack" },
    { id: "2568", name: "Issue2568: AFT - Fail" },
    { id: "2571", name: "Issue2571: Battery - Swelling" },
    { id: "2590", name: "Issue2590: Display - Dead Pixel" },
    { id: "2601", name: "Issue2601: Touch - Ghost" },
    { id: "2615", name: "Issue2615: WiFi - Drop" },
  ],
  config: [
    { id: "H1A", name: "H1A" },
    { id: "H1B2-AD-RC", name: "H1B2-AD-RC" },
    { id: "H1B2-AW", name: "H1B2-AW" },
    { id: "H5D1", name: "H5D1" },
    { id: "H5D2", name: "H5D2" },
    { id: "H3A-RC", name: "H3A-RC" },
  ],
  device: [
    { id: "DSN_001", name: "DSN-001" },
    { id: "DSN_002", name: "DSN-002" },
    { id: "DSN_003", name: "DSN-003" },
    { id: "DSN_004", name: "DSN-004" },
  ],
  testSequence: [
    { id: "TS_REAR_A", name: "Rear A" },
    { id: "TS_REAR_B", name: "Rear B" },
    { id: "TS_FRONT_A", name: "Front A" },
  ],
  readout: [
    { id: "R1", name: "Readout 1" },
    { id: "R2", name: "Readout 2" },
    { id: "R3", name: "Readout 3" },
  ],
  phaseBuild: [
    { id: "DVT-1.0", name: "DVT-1.0" },
    { id: "EVT-1.0", name: "EVT-1.0" },
    { id: "HVT-1.0", name: "HVT-1.0" },
  ],
  project: [
    { id: "P001", name: "Palomo" },
    { id: "P002", name: "Pisco" },
  ],
  cmLocation: [
    { id: "L001", name: "CM-Site-A (Shenzhen)" },
    { id: "L002", name: "CM-Site-B (Taipei)" },
  ],
  failedPart: [
    { id: "FP001", name: "Display Panel" },
    { id: "FP002", name: "Battery Cell" },
    { id: "FP003", name: "Touch Sensor" },
  ],
  recoveryType: [
    { id: "RT001", name: "Retest" },
    { id: "RT002", name: "Replace" },
    { id: "RT003", name: "RMA" },
  ],
  failureCategory: [
    { id: "FC001", name: "Hardware" },
    { id: "FC002", name: "Software" },
    { id: "FC003", name: "Environmental" },
  ],
};

function generateMockFailureRateTree(path: string[], depth = 0, parentTotal?: number): IFDDDFailureRateNode[] {
  if (depth >= path.length) return [];

  const dimension = path[depth];
  const pool = failureRateMockPools[dimension] ?? [
    { id: `${dimension}_1`, name: `${dimension} Item 1` },
    { id: `${dimension}_2`, name: `${dimension} Item 2` },
    { id: `${dimension}_3`, name: `${dimension} Item 3` },
  ];

  // More items at top level, fewer as we go deeper
  const maxItems = depth === 0 ? Math.min(pool.length, 4) : Math.min(pool.length, Math.max(2, 5 - depth));
  const count = Math.floor(Math.random() * (maxItems - 1)) + 2; // at least 2
  const shuffled = [...pool].sort(() => 0.5 - Math.random()).slice(0, count);

  const nodes: IFDDDFailureRateNode[] = [];
  let remainingTotal = parentTotal ?? 0;

  for (let i = 0; i < shuffled.length; i++) {
    const item = shuffled[i];
    // Top-level: generate a meaningful total; deeper levels: distribute parent's total
    let total: number;
    if (depth === 0) {
      total = Math.floor(Math.random() * 150) + 50; // 50-200
    } else if (i === shuffled.length - 1) {
      // Last child gets the remainder to ensure they roughly add up
      total = Math.max(5, remainingTotal);
    } else {
      total = Math.max(5, Math.floor((parentTotal ?? 162) * (Math.random() * 0.4 + 0.1)));
      remainingTotal -= total;
    }

    const failureRatio = Math.random() * 0.65 + 0.05; // 5%-70%
    const failures = Math.min(total, Math.max(1, Math.round(total * failureRatio)));
    const failureRate = total > 0 ? parseFloat((failures / total).toFixed(4)) : 0;

    nodes.push({
      id: `${item.id}_d${depth}`,
      name: item.name,
      dimension,
      total,
      failures,
      failureRate,
      children: generateMockFailureRateTree(path, depth + 1, total),
    });
  }

  return nodes;
}

// Preset mock data — in-memory store keyed by feature so CRUD operations persist across calls.
// NOTE: Default (built-in) presets are defined in the FDDD module constants (FDDD_DEFAULT_PRESETS).
// This store only holds user-created custom presets; defaults are prepended by the FE hook.
const presetStoreByFeature: Record<string, IPresetItem[]> = {
  FDDD: [{ uuid: "preset_custom_1", path: ["config", "test", "issue"], description: "Compare failure patterns by config" }],
};

// GET /api/get_presets?feature=FDDD — returns requestParameter as stringified JSON
axiosMockAdapterInstance.onGet(apiConfig.fetch_PresetList).reply(config => {
  const feature = config.params?.feature ?? "FDDD";
  const store = presetStoreByFeature[feature] ?? [];
  // Simulate API wire format: path → requestParameter (stringified)
  const wireData = store.map(({ path, ...rest }) => ({ ...rest, requestParameter: JSON.stringify(path) }));
  return [200, { isSuccess: true, data: wireData }];
});

// POST /api/update_presets — bulk replace; body: { data: [...], feature: "FDDD" }
axiosMockAdapterInstance.onPost(apiConfig.update_Presets).reply(config => {
  const body = JSON.parse(config.data);
  const feature: string = body.feature ?? "FDDD";
  const incoming: { uuid?: string; requestParameter?: string; description?: string; isDefault?: boolean }[] = body.data ?? [];
  // Parse requestParameter back to path and assign UUIDs; preserve isDefault flag
  const result: IPresetItem[] = incoming.map(p => ({
    uuid: p.uuid && !p.uuid.startsWith("temp_") ? p.uuid : `preset_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
    path: p.requestParameter ? JSON.parse(p.requestParameter) : [],
    description: p.description,
    ...(p.isDefault ? { isDefault: true } : {}),
  }));
  presetStoreByFeature[feature] = result;
  // Return wire format (stringified requestParameter)
  const wireData = result.map(({ path, ...rest }) => ({ ...rest, requestParameter: JSON.stringify(path) }));
  return [200, { isSuccess: true, data: wireData }];
});

axiosMockAdapterInstance.onPost(apiConfig.fetch_FDDD_FailureRateSummary).reply(config => {
  const body = config.data ? JSON.parse(config.data) : {};
  const path = body.path ?? ["test", "issue", "config"];

  return [
    200,
    {
      isSuccess: true,
      code: 200,
      data: generateMockFailureRateTree(Array.isArray(path) ? path : [path]),
    },
  ];
});
// Test Summary mock data
import { IAttachmentsByTest, IIssueDetail, IIssueSummaryData, IIssueSummaryItem, IReadoutDataByTest, ITestResultDeviceRow, ITestSummaryData } from "@/type/axios";

// ── Test Header ──────────────────────────────────────────────────────────────
const testSummaryHeaderData: ITestSummaryData = {
  testId: "free_drop_gn_1",
  testName: "Standard Free Drop - GN - Test - Lv1",
  testCategory: "Environmental",
  testLevel: "Level 1",
  testDescription:
    "• Level 1: Drop operational UUT from a height of 1m onto ¾ inch thick particle board (particle board with durometer hardness of 75 ± 5 Shore D) with concrete or steel floor underneath.\n\nRefer to the drop test report template for details of the 18 drop orientations.\n\nA subset of devices should play a video from the uSD card in order to test signal integrity, and also with the SIM card inserted. The number of devices is chosen by the reliability engineer.",
  testSchedule: { startDate: "07/05/2025", endDate: "07/16/2025" },
  overallFailureRate: "15F/45T",
  testConclusion: "Test ongoing with identified mechanical and cosmetic issues requiring attention.",
  status: "ongoing",
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSummary_Data).reply(200, {
  data: testSummaryHeaderData,
  message: "Test summary data fetched successfully",
  isSuccess: true,
});

// ── Issue Summary (GET /api/get_issue_summary) ────────────────────────────────
const issueSummaryItems: IIssueSummaryItem[] = [
  {
    issueId: 2871,
    issueType: "Failure | Mechanical",
    isFailure: true,
    issue: "#2871: Rear cover - Corner sharp deformation",
    failingComponent: "Rear cover",
    failureMode: "Corner sharp deformation",
    recovery: "Replace rear cover assembly",
    category: "Mechanical",
    jiraUrl: "https://jira.example.com/browse/Tungsten-1214",
    failedReadoutCount: 19,
    failedDeviceCount: 3,
    isNewIssue: false,
    isNewFailedReadout: true,
    isNewFailedDevice: false,
    createdTs: "2025-07-06T08:30:00Z",
  },
  {
    issueId: 2872,
    issueType: "Observation | Cosmetic",
    isFailure: false,
    issue: "#2872: Rear cover - Pop up (recover by manual pressing)",
    failingComponent: "Rear cover",
    failureMode: "Pop up",
    recovery: "Manual pressing recovers; monitor for recurrence",
    category: "Cosmetic",
    jiraUrl: "",
    failedReadoutCount: 27,
    failedDeviceCount: 15,
    isNewIssue: false,
    isNewFailedReadout: false,
    isNewFailedDevice: false,
    createdTs: "2025-07-07T10:15:00Z",
  },
];

const issueSummaryData: IIssueSummaryData = {
  pagination: { page: 1, pageSize: 20, totalItems: 2, totalPages: 1 },
  issueSummaryList: issueSummaryItems,
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_IssueSummary).reply(200, {
  data: issueSummaryData,
  message: "Issue summary fetched successfully",
  isSuccess: true,
});

// ── Issue Detail (GET /api/get_issue_detail) ──────────────────────────────────
const issueDetailMap: Record<number, IIssueDetail> = {
  2871: {
    issueId: 2871,
    issueType: "Failure | Mechanical",
    description: "#2871: Rear cover - Corner sharp deformation",
    jiraUrl: "https://jira.example.com/browse/Tungsten-1214",
    untrackedFailedDevices: 3,
    failureRateSummary: [
      { configName: "E-TQ1", failedCount: 1, totalCount: 6, failureRate: "1F/6T", radarPlusId: "E-TQ1_001", isNew: false },
      { configName: "E-TQ2", failedCount: 0, totalCount: 4, failureRate: "0F/4T", radarPlusId: "E-TQ2_001", isNew: false },
      { configName: "E-TQ3", failedCount: 0, totalCount: 5, failureRate: "0F/5T", radarPlusId: "E-TQ3_001", isNew: false },
      { configName: "E-TQ3A", failedCount: 4, totalCount: 7, failureRate: "4F/7T", radarPlusId: "E-TQ3A_001", isNew: true },
    ],
    failedDevicePhotos: {
      pagination: { page: 1, pageSize: 20, totalItems: 3, totalPages: 1 },
      items: [
        {
          dsn: "Tungsten-1214",
          shortId: "E-TQ3A_014",
          realDsn: "G0B4FB0452660028",
          failedReadoutOrder: 8,
          readoutName: "height (m)-1.0 : cycles-40",
          isNew: false,
          faStatus: "In Progress",
          photoUrls: ["https://example.com/presigned-url-issue-2871-1", "https://example.com/presigned-url-issue-2871-2"],
        },
        {
          dsn: "Tungsten-1235",
          shortId: "E-TQ3A_035",
          realDsn: "G0B4ME0152130086",
          failedReadoutOrder: 6,
          readoutName: "height (m)-0.8 : cycles-30",
          isNew: false,
          faStatus: "Open",
          photoUrls: [],
        },
        {
          dsn: "Tungsten-1238",
          shortId: "E-TQ3A_038",
          realDsn: "G0B4FB045252007V",
          failedReadoutOrder: 5,
          readoutName: "height (m)-0.5 : cycles-20",
          isNew: true,
          faStatus: null,
          photoUrls: [],
        },
      ],
    },
  },
  2872: {
    issueId: 2872,
    issueType: "Observation | Cosmetic",
    description: "#2872: Rear cover - Pop up (recover by manual pressing)",
    jiraUrl: "",
    untrackedFailedDevices: 0,
    failureRateSummary: [],
    failedDevicePhotos: {
      pagination: { page: 1, pageSize: 20, totalItems: 3, totalPages: 1 },
      items: [
        { dsn: "Tungsten-1201", shortId: "E-TQ1_001", realDsn: "G0B4FB0452520052", failedReadoutOrder: 2, readoutName: "Rear cover pop-up check", isNew: false, faStatus: "Closed", photoUrls: [] },
        { dsn: "Tungsten-1202", shortId: "E-TQ1_002", realDsn: "G0B4FB045252005N", failedReadoutOrder: 2, readoutName: "Rear cover pop-up check", isNew: false, faStatus: "Closed", photoUrls: [] },
        { dsn: "Tungsten-1203", shortId: "E-TQ1_003", realDsn: "G0B4PL0252640005", failedReadoutOrder: 1, readoutName: "Initial visual inspection", isNew: false, faStatus: "Open", photoUrls: [] },
      ],
    },
  },
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_IssueDetail).reply(config => {
  const issueId = Number(config.params?.issueId);
  const detail = issueDetailMap[issueId];
  if (!detail) {
    return [400, { isSuccess: false, code: 400, message: "Please provide a valid issue ID." }];
  }
  return [200, { data: detail, message: "Issue detail fetched successfully", isSuccess: true }];
});

// ── Readout Data By Test (GET /api/get_readout_data_by_test) ──────────────────
function generateReadoutDataByTest(): IReadoutDataByTest {
  const orientations = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
  const configs = ["E25NP-R", "E7NC-CR", "E7NC-R2", "E7NC-R", "EG1-R"];
  const deviceResults: ITestResultDeviceRow[] = [];
  let failedCount = 0;

  configs.forEach(config => {
    for (let i = 0; i < 5; i++) {
      const deviceDisplayName = `${config}_${String(i + 1).padStart(3, "0")}`;
      const realDsn = `G0B4${generateHexString(12)}`;
      const overallStatus = randomPick(["PASS", "FAIL", "ONGOING", "NOT_STARTED"] as const);
      if (overallStatus === "FAIL") failedCount++;

      const deviceIssues = overallStatus === "FAIL" ? [{ issueId: 2871, description: "#2871: Rear cover - Corner sharp deformation", type: "failure" }] : [];

      const readoutResults = orientations.map(order => {
        const result = overallStatus === "NOT_STARTED" ? null : randomPick(["1", "1", "1", "-1", "0"] as const);
        const issueIds = result === "0" ? [2871] : [];
        return { readoutOrder: order, readoutLabel: `Impact-${order * 48 + Math.floor(Math.random() * 10)}`, result, issueIds };
      });

      deviceResults.push({
        dsn: `TABLET_TUNGSTEN_DVT_1.0_${config}_${String(i + 1).padStart(3, "0")}`,
        realDsn,
        deviceDisplayName,
        configName: config,
        overallStatus,
        hasCmApproved: overallStatus === "FAIL" ? Math.random() < 0.5 : false,
        issues: deviceIssues,
        readoutResults,
      });
    }
  });

  const totalCount = deviceResults.length;
  return {
    orientations,
    failedCount,
    totalCount,
    failureRate: `${failedCount}F/${totalCount}T`,
    deviceResults,
  };
}

// ── Grouping Sequences (GET /api/get_grouping_sequences) ─────────────────────
const groupingSequencesList = ["Seq A", "Seq B", "Seq C", "Seq D", "Seq E", "Seq F"];

axiosMockAdapterInstance.onGet(apiConfig.fetch_GroupingSequences).reply(200, {
  data: groupingSequencesList.map(s => ({ groupingSequence: s })),
  message: "Grouping sequences fetched successfully",
  isSuccess: true,
});

axiosMockAdapterInstance.onGet(apiConfig.fetch_ReadoutDataByTest).reply(config => {
  // Each sequence call returns independently randomized data via Math.random()
  void (config.params?.groupingSequence as string | undefined);
  const data = generateReadoutDataByTest();
  return [200, { data, message: "Readout data fetched successfully", isSuccess: true }];
});

// ── Attachments By Test (GET /api/get_attachments_by_test) ───────────────────
const attachmentsByTestData: IAttachmentsByTest = {
  deviceAttachments: [
    {
      radarPlusId: "E25NP-R_015",
      attachments: [
        {
          presignedUrl: "https://example.com/presigned/FA_Report_20250724.pdf",
          fileName: "FA_Report_20250724.pdf",
          fileType: "PDF",
          readoutId: null,
          issueId: null,
        },
        {
          presignedUrl: "https://example.com/presigned/failure_photo_001.jpg",
          fileName: "failure_photo_001.jpg",
          fileType: "IMAGE",
          readoutId: 8,
          issueId: 2541,
        },
        {
          presignedUrl: "https://example.com/presigned/failure_photo_002.jpg",
          fileName: "failure_photo_002.jpg",
          fileType: "IMAGE",
          readoutId: 8,
          issueId: 2542,
        },
      ],
    },
    {
      radarPlusId: "E7NC-R2_019",
      attachments: [
        {
          presignedUrl: "https://example.com/presigned/diag_report_E7NC.pdf",
          fileName: "diag_report_E7NC.pdf",
          fileType: "PDF",
          readoutId: null,
          issueId: null,
        },
      ],
    },
    {
      radarPlusId: "EG1-R_003",
      attachments: [
        {
          presignedUrl: "https://example.com/presigned/failure_photo_EG1_001.jpg",
          fileName: "failure_photo_EG1_001.jpg",
          fileType: "IMAGE",
          readoutId: 5,
          issueId: 2871,
        },
      ],
    },
  ],
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_AttachmentsByTest).reply(200, {
  data: attachmentsByTestData,
  message: "Attachments fetched successfully",
  isSuccess: true,
});

// ── Write operations ──────────────────────────────────────────────────────────
axiosMockAdapterInstance.onPost(apiConfig.update_TestSummary_FAStatus).reply(200, {
  data: { success: true },
  message: "FA status updated successfully",
  isSuccess: true,
});

axiosMockAdapterInstance.onGet(apiConfig.export_TestSummary_Excel).reply(200, new Blob(["Mock Excel Data"], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

axiosMockAdapterInstance.onGet(apiConfig.download_TestReport).reply(200, new Blob(["Mock Test Report Excel"], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

axiosMockAdapterInstance.onGet(apiConfig.download_TestSummary_MeasurementData).reply(200, new Blob(["Mock Measurement Data"], { type: "application/octet-stream" }));

axiosMockAdapterInstance.onGet(apiConfig.download_TestSpec_List).reply(200, new Blob(["Mock Test Spec List Excel"], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

axiosMockAdapterInstance.onGet(apiConfig.download_FamilySpec_List).reply(200, new Blob(["Mock Family Spec List Excel"], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

// ── Operator Management (admin) Mock Data ─────────────────────────────

import { IOperator, IOperatorDevice, OperatorStatus } from "@/type/user";

const operatorDevicePools: { deviceName: string; ip: string }[] = [
  { deviceName: "Chrome 120.0 / macOS 14.2", ip: "203.0.113.10" },
  { deviceName: "Safari 17.2 / macOS 14.1", ip: "203.0.113.11" },
  { deviceName: "Firefox 121.0 / Windows 11", ip: "198.51.100.22" },
  { deviceName: "Chrome 119.0 / Windows 10", ip: "198.51.100.33" },
  { deviceName: "Edge 120.0 / Windows 11", ip: "192.0.2.44" },
  { deviceName: "Chrome 120.0 / Android 14", ip: "10.0.0.55" },
  { deviceName: "Safari 17.0 / iOS 17.2", ip: "10.0.0.66" },
];

function generateMockDevices(count: number): IOperatorDevice[] {
  const now = Date.now();
  return Array.from({ length: count }, (_, i) => {
    const pool = operatorDevicePools[i % operatorDevicePools.length];
    const daysAgo = Math.floor(Math.random() * 30);
    return {
      deviceKey: `us-west-2_${crypto.randomUUID?.() ?? Math.random().toString(36).slice(2)}`,
      deviceName: pool.deviceName,
      lastIpUsed: pool.ip,
      lastAuthenticatedDate: new Date(now - daysAgo * 86400000).toISOString(),
      createDate: new Date(now - (daysAgo + 30) * 86400000).toISOString(),
    };
  });
}

const operatorMockStore: IOperator[] = [
  { username: "op_alice", status: "active", activated: true, createDate: "2025-06-01T08:00:00Z", devices: generateMockDevices(2) },
  { username: "op_bob", status: "active", activated: true, createDate: "2025-07-15T10:30:00Z", devices: generateMockDevices(3) },
  { username: "op_charlie", status: "inactive", activated: false, createDate: "2025-08-20T14:00:00Z", devices: generateMockDevices(1) },
  { username: "op_diana", status: "pending", activated: false, createDate: "2026-03-25T09:00:00Z", devices: [] },
  { username: "op_edward", status: "active", activated: true, createDate: "2025-09-10T11:00:00Z", devices: generateMockDevices(2) },
  { username: "op_fiona", status: "disabled", activated: false, createDate: "2025-05-01T07:00:00Z", devices: generateMockDevices(1) },
  { username: "op_george", status: "active", activated: true, createDate: "2025-11-01T13:00:00Z", devices: generateMockDevices(2) },
  { username: "op_helen", status: "pending", activated: false, createDate: "2026-03-28T16:00:00Z", devices: [] },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_OperatorList).reply(200, {
  data: operatorMockStore,
  isSuccess: true,
  message: "Operator list fetched successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.create_Operator).reply(config => {
  const body = JSON.parse(config.data);
  const newOp: IOperator = {
    username: body.username,
    status: "pending" as OperatorStatus,
    activated: false,
    createDate: new Date().toISOString(),
    devices: [],
  };
  operatorMockStore.push(newOp);
  return [200, { data: { username: body.username, temporaryPassword: "Mock@Temp1!ab" }, isSuccess: true, message: `Operator "${body.username}" created.` }];
});

axiosMockAdapterInstance.onPost(apiConfig.delete_Operator).reply(config => {
  const body = JSON.parse(config.data);
  const idx = operatorMockStore.findIndex(o => o.username === body.username);
  if (idx >= 0) operatorMockStore.splice(idx, 1);
  return [200, { data: { success: true }, isSuccess: true, message: `Operator "${body.username}" deleted.` }];
});

axiosMockAdapterInstance.onPost(apiConfig.activate_Operator).reply(config => {
  const body = JSON.parse(config.data);
  const op = operatorMockStore.find(o => o.username === body.username);
  if (op) {
    op.activated = true;
    op.status = "active";
  }
  return [200, { data: { success: true }, isSuccess: true, message: `Operator "${body.username}" activated.` }];
});

axiosMockAdapterInstance.onPost(apiConfig.deactivate_Operator).reply(config => {
  const body = JSON.parse(config.data);
  const op = operatorMockStore.find(o => o.username === body.username);
  if (op) {
    op.activated = false;
    op.status = "inactive";
  }
  return [200, { data: { success: true }, isSuccess: true, message: `Operator "${body.username}" deactivated.` }];
});

axiosMockAdapterInstance.onPost(apiConfig.resetPassword_Operator).reply(config => {
  const body = JSON.parse(config.data);
  return [200, { data: { username: body.username, temporaryPassword: "Mock@Reset9!xy" }, isSuccess: true, message: `Password reset for "${body.username}".` }];
});

// ── Readout Input / Data Input Mock Data ──────────────────────────────
import type { IIssueListItem, IReadoutDeviceListItem, IReadoutFATPLogOption, IReadoutMetadata, IReadoutTestData } from "@/type/axios";

const mockReadoutTestData: IReadoutTestData = {
  id: 564070,
  familyId: "eink",
  projectId: "paloma",
  testLocationId: "shenzhen",
  phaseId: "proto",
  buildId: "1.0",
  dsn: "EINK_PALOMA_PROTO_1-DOT-0_P13KB-R_008",
  testId: "esd_air_discharge_test_1",
  testName: "ESD Air Discharge Test - L1",
  sequenceId: "1",
  displayName: "EINK / Paloma / Shenzhen / DVT 1.0",
  testStatus: "ongoing",
  testType: "esd",
  // num_zaps deliberately ABSENT (fresh-device shape): its option in the selector
  // exercises the upsert-append path — a plain update would drop the click and the
  // option would never highlight (1216844801835596).
  testVariable: [
    { key: "voltage", name: "Voltage", value: "+8kV" },
    { key: "location", name: "Location", value: "2" },
  ],
  readouts: [
    {
      id: 2364059,
      readoutId: 2364059,
      readoutDataId: 2648900,
      result: "fail",
      order: 1,
      isFinal: true,
      keyValuePair: [
        { key: "Voltage", value: "+8kV" },
        { key: "Location", value: "2" },
        { key: "Number of Zaps", value: "10" },
      ],
      // Verbatim capture of the live Polus EVT 99.1 readout (Asana 1217482994253231):
      // three components each with their own Pk/Bm/rPk/rBm, but CCP/CRP rows that all
      // share ONE equationParameters map because the binding is per-equation, not
      // per-component. Every CCP says {p: 25434 (Mute Button/Pk), b: 25441 (Volume Up/Bm)}
      // and every CRP says {p: 25459 (Volume Up/rPk), b: 25470 (Mute Button/rBm)}.
      // Resolving those ids literally made one component's inputs drive every
      // component's computed value; resolveEquationSource scopes them per component.
      // Keep as a regression fixture.
      measurements: [
        { id: 25470, avgMeasurementNum: 3, component: "Mute Button", name: "rBm", unit: "g" },
        { id: 25451, component: "Volume Down", name: "CCP", equation: "(p - b) / p", equationParameters: { b: 25441, p: 25434 } },
        { id: 25459, avgMeasurementNum: 3, component: "Volume Up", name: "rPk", unit: "g" },
        { id: 25441, avgMeasurementNum: 3, component: "Volume Up", name: "Bm", unit: "g" },
        { id: 25450, component: "Volume Up", name: "CCP", equation: "(p - b) / p", equationParameters: { b: 25441, p: 25434 } },
        { id: 25479, component: "Mute Button", name: "CRP", equation: "(p - b) / p", equationParameters: { b: 25470, p: 25459 } },
        { id: 25434, avgMeasurementNum: 3, component: "Mute Button", name: "Pk", unit: "g" },
        { id: 25433, avgMeasurementNum: 3, component: "Volume Down", name: "Pk", unit: "g" },
        { id: 25477, component: "Volume Up", name: "CRP", equation: "(p - b) / p", equationParameters: { b: 25470, p: 25459 } },
        { id: 25469, avgMeasurementNum: 3, component: "Volume Down", name: "rBm", unit: "g" },
        { id: 25468, avgMeasurementNum: 3, component: "Volume Up", name: "rBm", unit: "g" },
        { id: 25452, component: "Mute Button", name: "CCP", equation: "(p - b) / p", equationParameters: { b: 25441, p: 25434 } },
        { id: 25443, avgMeasurementNum: 3, component: "Mute Button", name: "Bm", unit: "g" },
        { id: 25432, avgMeasurementNum: 3, component: "Volume Up", name: "Pk", unit: "g" },
        { id: 25461, avgMeasurementNum: 3, component: "Mute Button", name: "rPk", unit: "g" },
        { id: 25442, avgMeasurementNum: 3, component: "Volume Down", name: "Bm", unit: "g" },
        { id: 25478, component: "Volume Down", name: "CRP", equation: "(p - b) / p", equationParameters: { b: 25470, p: 25459 } },
        { id: 25460, avgMeasurementNum: 3, component: "Volume Down", name: "rPk", unit: "g" },
      ],
      checks: [
        { id: 1, key: "functional_check", name: "Functional Check", checkCategory: "default", status: "pass" },
        // Intentional permanent fixture (do NOT remove): a duplicate-key row
        // reproducing Asana 1216775626692575. The FE dedupes on load
        // (dedupeChecksByKey) so this must render only once — regression guard.
        { id: 100, key: "functional_check", name: "Functional Check", checkCategory: "default", status: "pass" },
        {
          id: 2,
          key: "visual_inspection",
          name: "Visual Inspection",
          checkCategory: "default",
          status: "fail",
          issue: [
            {
              issueId: 2555,
              details: "Display - Black(recover by pressing mute button)",
              failingComponent: "Display",
              failureMode: "Black screen",
              severity: "Failure",
              category: "Functional",
              translation: {},
              comment: "",
              attachment: [],
            },
          ],
        },
        {
          id: 3,
          key: "aft",
          name: "AFT",
          checkCategory: "fatp",
          status: "pass",
          fatp: { serialId: "G0B4ME0152440009", testResult: "pass", startTime: "20250613_152721", process: "FATP", station: "AFT", errorCode: "PASS" },
        },
        {
          id: 4,
          key: "arf",
          name: "ARF",
          checkCategory: "fatp",
          status: "pass",
          fatp: { serialId: "G0B4ME0152440009", testResult: "pass", startTime: "20250620_102630", process: "FATP", station: "ARF", errorCode: "PASS" },
        },
        {
          id: 5,
          key: "aut",
          name: "AUT",
          checkCategory: "fatp",
          status: "fail",
          fatp: { serialId: "G0B4ME0152440009", testResult: "fail", startTime: "20250820_145225", process: "FATP", station: "AUT", errorCode: "FAIL:^^^Error-168:temp_test" },
        },
        { id: 6, key: "listening", name: "Listening", checkCategory: "fatp", status: "na" },
        { id: 7, key: "mic_seal", name: "Mic Seal", checkCategory: "fatp", status: "na" },
      ],
    },
    {
      id: 2364060,
      readoutId: 2364060,
      readoutDataId: 2648901,
      result: "pass",
      order: 2,
      isFinal: false,
      keyValuePair: [
        { key: "Voltage", value: "+8kV" },
        { key: "Location", value: "2" },
        { key: "Number of Zaps", value: "10" },
      ],
      measurements: [],
      checks: [
        { id: 8, key: "functional_check", name: "Functional Check", checkCategory: "default", status: "pass" },
        { id: 9, key: "visual_inspection", name: "Visual Inspection", checkCategory: "default", status: "pass" },
      ],
    },
  ],
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_ReadoutInput_TestData).reply(200, {
  data: mockReadoutTestData,
  isSuccess: true,
  message: "Test data fetched successfully",
});

const mockDeviceList: IReadoutDeviceListItem[] = [
  { dsn: "EINK_PALOMA_PROTO_1-DOT-0_P13KB-R_008", shortId: "A001" },
  { dsn: "EINK_PALOMA_PROTO_1-DOT-0_P13KB-R_009", shortId: "A002" },
  { dsn: "EINK_PALOMA_PROTO_1-DOT-0_P13KB-R_010", shortId: "A003" },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_ReadoutInput_DeviceList).reply(200, {
  data: mockDeviceList,
  isSuccess: true,
});

const mockIssueList: IIssueListItem[] = [
  { issueId: 2555, details: "Display - Black(recover by pressing mute button)", failingComponent: "Display", failureMode: "Black screen", severity: "Failure", category: "Functional", translation: {} },
  { issueId: 3216, details: "Display - Black(recover by pressing mute button)", failingComponent: "Display", failureMode: "Black screen", severity: "Failure", category: "Functional", translation: {} },
  { issueId: 3217, details: "Speaker - No audio output", failingComponent: "Speaker", failureMode: "No audio output", severity: "Failure", category: "Functional", translation: {} },
  { issueId: 3218, details: "Touch - Ghost touches", failingComponent: "Touch", failureMode: "Ghost touches", severity: "Observation", category: "Functional", translation: {} },
  { issueId: 3219, details: "Battery - Abnormal drain", failingComponent: "Battery", failureMode: "Abnormal drain", severity: "Failure", category: "Functional", translation: {} },
  { issueId: 3220, details: "WiFi - Connection drops", failingComponent: "WiFi", failureMode: "Connection drops", severity: "Observation", category: "Functional", translation: {} },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_IssueList).reply(200, {
  data: mockIssueList,
  isSuccess: true,
});

// serialId is the device DSN (identical across rows); startTime is the per-log
// discriminator used as the option key. Mirrors GetFatpGenealogy output.
const mockFATPLogOptions: IReadoutFATPLogOption[] = [
  { serialId: "G0B4ME0152440009", testResult: "pass", startTime: "20250613_152721", process: "FATP", station: "AFT", errorCode: "PASS" },
  { serialId: "G0B4ME0152440009", testResult: "pass", startTime: "20250620_102630", process: "FATP", station: "AFT", errorCode: "PASS" },
  { serialId: "G0B4ME0152440009", testResult: "fail", startTime: "20250820_145225", process: "FATP", station: "AFT", errorCode: "FAIL:^^^Error-168:temp_test" },
  { serialId: "G0B4ME0152440009", testResult: "pass", startTime: "20250830_092247", process: "REL", station: "AFT", errorCode: "PASS" },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_ReadoutInput_FATPLogOptions).reply(200, {
  data: mockFATPLogOptions,
  isSuccess: true,
});

// Raw CSV blob, no BaseResponse envelope — mirrors DownloadFatpCandidateLogs. Four limit/metadata
// rows sit above the header, then one row per candidate log, so the mock exercises the real shape
// the download handler saves. A single parameter column is enough here. Leading BOM so Excel reads
// the file as UTF-8, matching what the BE writes.
const mockFATPCandidateLogsCsv =
  "﻿Errorcode,,,,,,,,,,,,,,,,,,07-000\r\n" +
  "Upperlimit,,,,,,,,,,,,,,,,,,18\r\n" +
  "Lowerlimit,,,,,,,,,,,,,,,,,,6\r\n" +
  "Units,,,,,,,,,,,,,,,,,,dBm\r\n" +
  "serial_id,factory_id,project_name,build_config,start_time,operator,station,fixture_id,cycle_time,diag_ver,gui_ver,route_check,image_name_ver,build,test_result,testplan_crc,testplan_ip,result_validation,wifi_power_avg\r\n" +
  "G0B323013242002G,ENSKY,CYPRESS,,20230705_145008,,ARF2,,,,,,,HVT,PASS,,,,11.922\r\n";

axiosMockAdapterInstance.onGet(apiConfig.download_FATPCandidateLogs).reply(200, new Blob([mockFATPCandidateLogsCsv], { type: "text/csv;charset=utf-8" }));

// Combined metadata mock: variable dropdowns + final-only checks and measurements.
// IDs are deliberately high to avoid colliding with base readout entries.
const mockReadoutMetadata: IReadoutMetadata = {
  finalChecks: [
    { id: 9001, key: "aft", name: "AFT" },
    { id: 9002, key: "rft", name: "RFT" },
  ],
  // Deliberately listed out of `order` so a regression in MeasurementSection's sort is
  // visible in the mock UI: the computed CCP (order 2) is sent first but must render
  // between rPk (1) and Bm (3), never beside another computed row.
  finalMeasurements: [
    {
      id: 999003,
      component: "Final Component",
      name: "CCP",
      order: 2,
      equation: "(p - b) / p",
      equationParameters: { p: 999001, b: 999002 },
    },
    { id: 999001, component: "Final Component", name: "rPk", unit: "g", order: 1, avgMeasurementNum: 3 },
    { id: 999002, component: "Final Component", name: "Bm", unit: "g", order: 3, avgMeasurementNum: 3 },
  ],
  variableSelections: [
    { key: "voltage", name: "Voltage", values: ["+2kV", "+4kV", "+8kV"] },
    { key: "location", name: "Location", values: ["1", "2", "3", "4", "5"] },
    { key: "num_zaps", name: "Number of Zaps", values: ["5", "10", "15"] },
  ],
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_ReadoutInput_Metadata).reply(200, {
  data: mockReadoutMetadata,
  isSuccess: true,
});

axiosMockAdapterInstance.onPost(apiConfig.save_ReadoutInput).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Readout data saved successfully",
});

// ── Test Settings ─────────────────────────────────────────────────────────────
import { FINAL_READOUT_ORDER, ITestSettingsCheckMappingData, ITestSettingsEquipment, ITestSettingsMeasurementMappingData, ITestSettingsReadout, ITestSettingsSequence, ITestSettingsTestVariable, PRE_TEST_READOUT_ORDER } from "@/type/axios";

// ── Equipment ─────────────────────────────────────────────────────────────────
const testSettings_EquipmentList: ITestSettingsEquipment[] = [
  { equipmentId: "eq-tn-thc-1", equipmentName: "Temperature & Humidity Chamber_1#", location: "Taiyuan(VN)" },
  { equipmentId: "eq-tn-thc-2", equipmentName: "Temperature & Humidity Chamber_2#", location: "Taiyuan(VN)" },
  { equipmentId: "eq-tn-thc-3", equipmentName: "Temperature & Humidity Chamber_3#", location: "Taiyuan(VN)" },
  { equipmentId: "eq-tn-esd-1", equipmentName: "ESD Tester_1#", location: "Taiyuan(VN)" },
  { equipmentId: "eq-tn-esd-2", equipmentName: "ESD Tester_2#", location: "Taiyuan(VN)" },
  { equipmentId: "eq-nc-thc-1", equipmentName: "Temperature & Humidity Chamber_1#", location: "Nanchang(CN)" },
  { equipmentId: "eq-nc-thc-2", equipmentName: "Temperature & Humidity Chamber_2#", location: "Nanchang(CN)" },
  { equipmentId: "eq-nc-esd-1", equipmentName: "ESD Tester_1#", location: "Nanchang(CN)" },
  { equipmentId: "eq-nc-esd-2", equipmentName: "ESD Tester_2#", location: "Nanchang(CN)" },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_EquipmentList).reply(200, {
  data: testSettings_EquipmentList,
  isSuccess: true,
});

// ── Equipment List from Test Fidelity ─────────────────────────────────────────
// This endpoint fetches available equipment from the Test Fidelity system,
// used to populate the Equipment dropdown in the Edit Sequence dialog.
const testSettings_EquipmentList_TestFidelity: ITestSettingsEquipment[] = [
  // Taiyuan(VN) — Temperature & Humidity Chambers
  { equipmentId: "tf-tn-thc-1", equipmentName: "Temperature & Humidity Chamber_1#", location: "Taiyuan(VN)" },
  { equipmentId: "tf-tn-thc-2", equipmentName: "Temperature & Humidity Chamber_2#", location: "Taiyuan(VN)" },
  { equipmentId: "tf-tn-thc-3", equipmentName: "Temperature & Humidity Chamber_3#", location: "Taiyuan(VN)" },
  { equipmentId: "tf-tn-thc-4", equipmentName: "Temperature & Humidity Chamber_4#", location: "Taiyuan(VN)" },
  // Taiyuan(VN) — ESD Testers
  { equipmentId: "tf-tn-esd-1", equipmentName: "ESD Tester_1#", location: "Taiyuan(VN)" },
  { equipmentId: "tf-tn-esd-2", equipmentName: "ESD Tester_2#", location: "Taiyuan(VN)" },
  { equipmentId: "tf-tn-esd-3", equipmentName: "ESD Tester_3#", location: "Taiyuan(VN)" },
  // Taiyuan(VN) — Drop Towers
  { equipmentId: "tf-tn-dt-1", equipmentName: "Drop Tower_1#", location: "Taiyuan(VN)" },
  { equipmentId: "tf-tn-dt-2", equipmentName: "Drop Tower_2#", location: "Taiyuan(VN)" },
  // Taiyuan(VN) — Vibration Tables
  { equipmentId: "tf-tn-vt-1", equipmentName: "Vibration Table_1#", location: "Taiyuan(VN)" },
  { equipmentId: "tf-tn-vt-2", equipmentName: "Vibration Table_2#", location: "Taiyuan(VN)" },
  // Nanchang(CN) — Temperature & Humidity Chambers
  { equipmentId: "tf-nc-thc-1", equipmentName: "Temperature & Humidity Chamber_1#", location: "Nanchang(CN)" },
  { equipmentId: "tf-nc-thc-2", equipmentName: "Temperature & Humidity Chamber_2#", location: "Nanchang(CN)" },
  { equipmentId: "tf-nc-thc-3", equipmentName: "Temperature & Humidity Chamber_3#", location: "Nanchang(CN)" },
  // Nanchang(CN) — ESD Testers
  { equipmentId: "tf-nc-esd-1", equipmentName: "ESD Tester_1#", location: "Nanchang(CN)" },
  { equipmentId: "tf-nc-esd-2", equipmentName: "ESD Tester_2#", location: "Nanchang(CN)" },
  // Nanchang(CN) — Drop Towers
  { equipmentId: "tf-nc-dt-1", equipmentName: "Drop Tower_1#", location: "Nanchang(CN)" },
  // Nanchang(CN) — Vibration Tables
  { equipmentId: "tf-nc-vt-1", equipmentName: "Vibration Table_1#", location: "Nanchang(CN)" },
  { equipmentId: "tf-nc-vt-2", equipmentName: "Vibration Table_2#", location: "Nanchang(CN)" },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_EquipmentListForSequence).reply(config => {
  // The real API takes a `cm` query param; mock returns all equipment regardless of cm value
  void (config.params?.cm as string | undefined);
  return [
    200,
    {
      isSuccess: true,
      code: 200,
      equipments: testSettings_EquipmentList_TestFidelity.map(eq => ({
        equipmentName: eq.equipmentName,
        category: eq.category ?? "General",
        location: eq.location,
        isAvailable: true,
      })),
    },
  ];
});

// ── Sequences ─────────────────────────────────────────────────────────────────
const testSettings_SequenceList: ITestSettingsSequence[] = [
  {
    sequenceId: 1,
    groupingSequence: "Map1",
    readoutCount: 240,
    majorReadoutCount: 8,
    defaultDuration: 2,
    skipNonWorkingDays: true,
    averageCapacity: 10,
    equipmentCount: 2,
    equipmentList: [
      { equipmentId: "tf-tn-esd-1", equipmentName: "ESD Tester_1#", category: "ESD", location: "Taiyuan(VN)" },
      { equipmentId: "tf-tn-esd-2", equipmentName: "ESD Tester_2#", category: "ESD", location: "Taiyuan(VN)" },
    ],
    hasData: true,
  },
  {
    sequenceId: 2,
    groupingSequence: "Map2",
    readoutCount: 320,
    majorReadoutCount: 8,
    defaultDuration: 3,
    skipNonWorkingDays: true,
    averageCapacity: 10,
    equipmentCount: 2,
    equipmentList: [
      { equipmentId: "tf-tn-thc-1", equipmentName: "Temperature & Humidity Chamber_1#", category: "Chamber", location: "Taiyuan(VN)" },
      { equipmentId: "tf-tn-thc-2", equipmentName: "Temperature & Humidity Chamber_2#", category: "Chamber", location: "Taiyuan(VN)" },
    ],
    hasData: true,
  },
  {
    sequenceId: 3,
    groupingSequence: "Map3",
    readoutCount: 180,
    majorReadoutCount: 8,
    defaultDuration: 1,
    skipNonWorkingDays: true,
    averageCapacity: 10,
    equipmentCount: 0,
    equipmentList: [],
    hasData: false,
  },
  {
    sequenceId: 4,
    groupingSequence: "Map4",
    readoutCount: 150,
    majorReadoutCount: 8,
    defaultDuration: 1,
    skipNonWorkingDays: true,
    averageCapacity: 10,
    equipmentCount: 0,
    equipmentList: [],
    hasData: false,
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_SequenceList).reply(200, {
  data: testSettings_SequenceList,
  isSuccess: true,
});

axiosMockAdapterInstance.onPost(apiConfig.add_TestSettings_Sequence).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Sequence added successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.edit_TestSettings_Sequence).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Sequence updated successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.delete_TestSettings_Sequence).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Sequence deleted successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.copy_TestSettings_Sequence).reply(200, {
  data: { copiedCount: 2, skippedSequences: [] },
  isSuccess: true,
  message: "Sequence copied successfully",
});

// ── Copy Sequence Options ─────────────────────────────────────────────────────
// sourceSequences is at root level per API spec (not under data)
axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_CopySequenceOptions).reply(() => {
  return [
    200,
    {
      isSuccess: true,
      code: 200,
      sourceSequences: [
        { groupingSequence: "Map1", readoutCount: 260, majorReadoutCount: 8, isSelectable: true },
        { groupingSequence: "Map2", readoutCount: 260, majorReadoutCount: 8, isSelectable: true },
        { groupingSequence: "Map2-1", readoutCount: 260, majorReadoutCount: 8, isSelectable: false, reason: "Destination already has data" },
        { groupingSequence: "Map2-2", readoutCount: 260, majorReadoutCount: 8, isSelectable: true },
        { groupingSequence: "Map3-1", readoutCount: 260, majorReadoutCount: 8, isSelectable: true },
        { groupingSequence: "Map3-2", readoutCount: 260, majorReadoutCount: 8, isSelectable: true },
      ],
    },
  ];
});

// ── Delete Sequence Options ───────────────────────────────────────────────────
// sequences is at root level per API spec (not under data)
axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_DeleteSequenceOptions).reply(() => {
  return [
    200,
    {
      isSuccess: true,
      code: 200,
      sequences: testSettings_SequenceList.map(seq => ({
        groupingSequence: seq.groupingSequence,
        isDeletable: !seq.hasData,
        reason: seq.hasData ? "Sequence has data filled and cannot be deleted" : undefined,
      })),
    },
  ];
});

// ── Readout Type Master (keys) ────────────────────────────────────────────────
const testSettings_ReadoutTypeMasterKeys = [
  "",
  "#",
  "0.5m",
  "0°C, cycles",
  "1",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "1m",
  "2",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "2B check",
  "2H check",
  "3",
  "30",
  "31",
  "32",
  "33",
  "34",
  "Voltage",
  "Location",
  "Number of Zaps",
  "Temperature",
  "Humidity",
  "Pressure",
  "Height",
  "Orientation",
  "Duration",
  "Frequency",
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_ReadoutTypeMaster).reply(200, {
  keys: testSettings_ReadoutTypeMasterKeys,
  isSuccess: true,
  code: 200,
});

// ── Readouts (per sequence) ───────────────────────────────────────────────────
// Generate 24 ESD readouts for Map1 (Voltage +8kV, L1-L24, 10 zaps)
function generateESDReadouts(count: number): ITestSettingsReadout[] {
  return Array.from({ length: count }, (_, i) => ({
    readoutId: `ro-map1-${i + 1}`,
    order: i + 1,
    type: "Voltage",
    value: `+8kV | Location : L${i + 1} | Number of zaps : 10`,
    majorReadout: i % 3 === 0, // every 3rd readout is major
    hasData: i < 8, // first 8 have data
  }));
}

// Map1 readouts (ESD test)
const testSettings_ReadoutList_Map1: ITestSettingsReadout[] = generateESDReadouts(24);

// Map2 readouts (Temperature cycling)
const testSettings_ReadoutList_Map2: ITestSettingsReadout[] = Array.from({ length: 32 }, (_, i) => ({
  readoutId: `ro-map2-${i + 1}`,
  order: i + 1,
  type: "Temperature",
  value: `${-40 + i * 5}°C | Duration : 30min | Humidity : 85%RH`,
  majorReadout: i % 4 === 0,
  hasData: i < 8,
}));

// Map3 readouts (Drop test)
const testSettings_ReadoutList_Map3: ITestSettingsReadout[] = Array.from({ length: 18 }, (_, i) => ({
  readoutId: `ro-map3-${i + 1}`,
  order: i + 1,
  type: "Height",
  value: `1.0m | Orientation : ${i + 1} | Surface : Particle Board`,
  majorReadout: i % 6 === 0,
  hasData: false,
}));

// Map4 readouts (Vibration test)
const testSettings_ReadoutList_Map4: ITestSettingsReadout[] = Array.from({ length: 15 }, (_, i) => ({
  readoutId: `ro-map4-${i + 1}`,
  order: i + 1,
  type: "Frequency",
  value: `${10 + i * 5}Hz | Duration : 60min | Axis : ${["X", "Y", "Z"][i % 3]}`,
  majorReadout: i % 5 === 0,
  hasData: false,
}));

const readoutsBySequence: Record<string, ITestSettingsReadout[]> = {
  Map1: testSettings_ReadoutList_Map1,
  Map2: testSettings_ReadoutList_Map2,
  Map3: testSettings_ReadoutList_Map3,
  Map4: testSettings_ReadoutList_Map4,
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_ReadoutList).reply(config => {
  const sequenceId = config.params?.sequenceId as string | undefined;
  const readouts = (sequenceId ? readoutsBySequence[sequenceId] : undefined) ?? testSettings_ReadoutList_Map1;
  return [200, { data: readouts, isSuccess: true }];
});

axiosMockAdapterInstance.onPost(apiConfig.add_TestSettings_Readout).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Readout added successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.edit_TestSettings_Readout).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Readout updated successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.delete_TestSettings_Readout).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Readout deleted successfully",
});

axiosMockAdapterInstance.onGet(apiConfig.download_TestSettings_ReadoutTemplate).reply(200, {
  isSuccess: true,
  code: 200,
  fileContent: btoa("Mock Readout Template"),
  fileName: "readout_template.xlsx",
});

axiosMockAdapterInstance.onPost(apiConfig.upload_TestSettings_Readouts).reply(200, {
  data: { success: true, importedCount: 24 },
  isSuccess: true,
  message: "24 readouts imported successfully",
});

// ── Check Mapping (spec-correct: allChecks + assignedChecks per row) ──────────
const allChecks = [
  { checkId: 1, checkCode: "AFT", checkName: "AFT Check" },
  { checkId: 2, checkCode: "ARF", checkName: "ARF Check" },
  { checkId: 3, checkCode: "VI", checkName: "Visual Inspection" },
  { checkId: 4, checkCode: "FC", checkName: "Functional Check" },
];

function generateCheckMappingData(readouts: ITestSettingsReadout[]): ITestSettingsCheckMappingData {
  return {
    allChecks,
    data: readouts.map(ro => {
      const assigned = [];
      if (ro.majorReadout) assigned.push(allChecks[0], allChecks[1]); // AFT + ARF for major
      assigned.push(allChecks[2]); // VI always
      if (ro.order % 4 === 0) assigned.push(allChecks[3]); // FC every 4th
      return {
        readoutOrder: ro.order,
        readoutLabel: ro.value,
        isMajorReadout: ro.majorReadout,
        hasData: ro.hasData,
        assignedChecks: assigned,
      };
    }),
  };
}

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_CheckMapping).reply(config => {
  const sequenceId = config.params?.sequenceId as string | undefined;
  const readouts = (sequenceId ? readoutsBySequence[sequenceId] : undefined) ?? testSettings_ReadoutList_Map1;
  return [200, { data: generateCheckMappingData(readouts), isSuccess: true }];
});

axiosMockAdapterInstance.onPost(apiConfig.update_TestSettings_CheckMapping).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Check mapping updated successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.reset_TestSettings_CheckMapping).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Check mapping reset successfully",
});

// ── Measurement Mapping (spec-correct: readouts + availableMeasurements + prePostSummary) ──
const availableMeasurements = [
  { measurementComponentMappingId: 10, measurementName: "Ambient Temperature", componentName: "Sensor A", unit: "°C", upperLimit: 85.0, lowerLimit: -40.0, order: 1 },
  { measurementComponentMappingId: 11, measurementName: "Atmospheric Pressure", componentName: "Sensor B", unit: "hPa", upperLimit: 1100.0, lowerLimit: 800.0, order: 2 },
  { measurementComponentMappingId: 12, measurementName: "Relative Humidity", componentName: "Sensor C", unit: "%RH", upperLimit: 95.0, lowerLimit: 10.0, order: 3 },
  { measurementComponentMappingId: 13, measurementName: "Volume Up Button Click Force", componentName: "Button", unit: "N", upperLimit: 5.0, lowerLimit: 0.5, order: 4 },
  { measurementComponentMappingId: 14, measurementName: "Volume Up Button Click Ratio", componentName: "Button", unit: "%", upperLimit: 100.0, lowerLimit: 0.0, order: 5 },
  { measurementComponentMappingId: 15, measurementName: "Volume Down Button Click Force", componentName: "Button", unit: "N", upperLimit: 5.0, lowerLimit: 0.5, order: 6 },
  { measurementComponentMappingId: 16, measurementName: "Volume Down Button Click Ratio", componentName: "Button", unit: "%", upperLimit: 100.0, lowerLimit: 0.0, order: 7 },
  { measurementComponentMappingId: 17, measurementName: "Power Button Click Force", componentName: "Button", unit: "N", upperLimit: 5.0, lowerLimit: 0.5, order: 8 },
  { measurementComponentMappingId: 18, measurementName: "Display Brightness", componentName: "Display", unit: "nits", upperLimit: 1000.0, lowerLimit: 0.0, order: 9 },
  { measurementComponentMappingId: 19, measurementName: "Battery Voltage", componentName: "Battery", unit: "V", upperLimit: 4.4, lowerLimit: 3.0, order: 10 },
];

/**
 * Mirrors the real get_readout_measurements shape: the Pre-Test bucket (order 0) first, then one row
 * per real readout in query order, then the Final Readout bucket (order -1). Both virtual buckets
 * are always present even when nothing is mapped to them, and they are stored with
 * test_readout_id IS NULL — they are not real readouts sliced off either end of the list.
 */
function generateMeasurementMappingData(readouts: ITestSettingsReadout[]): ITestSettingsMeasurementMappingData {
  let mappingIdCounter = 1;

  const mockReadouts = [
    {
      readoutOrder: PRE_TEST_READOUT_ORDER,
      readoutLabel: "Pre-Test",
      mappings: [10, 11, 12].map(mcmId => ({
        mappingId: mappingIdCounter++,
        readoutOrder: PRE_TEST_READOUT_ORDER,
        measurementComponentMappingId: mcmId,
        type: "PRE-TEST" as const,
        // Pre-Test measurements are the ones that carry data in practice.
        dataFilled: true,
      })),
    },
    ...readouts.map(ro => ({
      readoutOrder: ro.order,
      readoutLabel: ro.value,
      mappings: ro.majorReadout
        ? [10, 11, 12, 13, 14, 15, 16].map(mcmId => ({
            mappingId: mappingIdCounter++,
            readoutOrder: ro.order,
            measurementComponentMappingId: mcmId,
            type: "DEFAULT" as const,
            dataFilled: ro.hasData,
          }))
        : [],
    })),
    {
      readoutOrder: FINAL_READOUT_ORDER,
      readoutLabel: "Final Readout",
      mappings: availableMeasurements.slice(0, 3).map(m => ({
        mappingId: mappingIdCounter++,
        readoutOrder: FINAL_READOUT_ORDER,
        measurementComponentMappingId: m.measurementComponentMappingId,
        type: "FINAL" as const,
        // FINAL rows carry no measurement data, so they stay editable.
        dataFilled: false,
      })),
    },
  ];

  return {
    readouts: mockReadouts,
    availableMeasurements,
    prePostSummary: availableMeasurements.slice(0, 3).map(m => ({
      measurementComponentMappingId: m.measurementComponentMappingId,
      hasPreTest: true,
      hasPostTest: true,
    })),
  };
}

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_MeasurementMapping).reply(config => {
  const sequenceId = config.params?.sequenceId as string | undefined;
  const readouts = (sequenceId ? readoutsBySequence[sequenceId] : undefined) ?? testSettings_ReadoutList_Map1;
  return [200, { data: generateMeasurementMappingData(readouts), isSuccess: true }];
});

axiosMockAdapterInstance.onPost(apiConfig.update_TestSettings_MeasurementMapping).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Measurement mapping updated successfully",
});

// ── Test Variables ────────────────────────────────────────────────────────────
const testSettings_TestVariables: ITestSettingsTestVariable[] = [
  {
    variableKey: "ADAPTER",
    variableName: "Adapter",
    variableValues: ["No adapter", "9W adapter", "15W adapter"],
    applyStatus: true,
  },
  {
    variableKey: "IMAGE",
    variableName: "Image",
    variableValues: ["User", "Diag"],
    applyStatus: true,
  },
  {
    variableKey: "HEIGHT",
    variableName: "Height",
    variableValues: ["16cm", "24cm", "32cm"],
    applyStatus: false,
  },
  {
    variableKey: "ORIENTATION",
    variableName: "Orientation",
    variableValues: ["Portrait", "Landscape"],
    applyStatus: true,
  },
  {
    variableKey: "TEMPERATURE",
    variableName: "Temperature",
    variableValues: ["-20°C", "25°C", "60°C"],
    applyStatus: false,
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestSettings_TestVariables).reply(200, {
  data: testSettings_TestVariables,
  isSuccess: true,
});

axiosMockAdapterInstance.onPost(apiConfig.update_TestSettings_TestVariableApplyStatus).reply(config => {
  const body = JSON.parse(config.data);
  const variable = testSettings_TestVariables.find(v => v.variableKey === body.variableKey);
  if (variable) {
    variable.applyStatus = body.applyStatus;
  }
  return [200, { isSuccess: true, code: 200, message: "Test variable apply status updated successfully" }];
});

// Test Assignment mock data
import { ITestAssignmentItem } from "@/type/axios";

const fetch_TestAssignment_List: ITestAssignmentItem[] = [
  {
    testCode: "environmental_long_term_operational_stress_test_1",
    testNameAndLevel: "Long Term Operational Stress Test - Lv1",
    testExecutionCompleted: 7,
    testExecutionTotal: 7,
    overdueToStart: 0,
    awaitingReview: 6,
    nextDueDate: "",
    operator: ["liuzilin"],
  },
  {
    testCode: "baseline_check_1",
    testNameAndLevel: "Baseline Check Test - Lv1",
    testExecutionCompleted: 521,
    testExecutionTotal: 600,
    overdueToStart: 0,
    awaitingReview: 75,
    nextDueDate: "2025-12-10",
    operator: ["Hoi"],
  },
  {
    testCode: "ball_impact_front",
    testNameAndLevel: "Ball Impact Front Side Test - Lv1",
    testExecutionCompleted: 24,
    testExecutionTotal: 58,
    overdueToStart: 25,
    awaitingReview: 2,
    nextDueDate: "2025-12-12",
    operator: ["Hoi"],
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_TestAssignment_List).reply(200, {
  data: fetch_TestAssignment_List,
});

axiosMockAdapterInstance.onPost(apiConfig.update_TestAssignment).reply(200, {
  isSuccess: true,
  code: 200,
  message: "Successfully assigned tests to operators",
  totalAssignments: 6,
});

// OP List mock data
import { IOPOption } from "@/type/axios";

const fetch_OP_List: IOPOption[] = [
  { firstName: "Andrew", lastName: "Brannon", username: "abrannon" },
  { firstName: "tian", lastName: "tao", username: "tiantao" },
  { firstName: "xiaoman", lastName: "fu", username: "xiaomanfu" },
  { firstName: "jinjun", lastName: "xia", username: "jinjunxia" },
  { firstName: "li", lastName: "huamei", username: "lihuamei" },
  { firstName: "junjie", lastName: "liu", username: "ljj" },
  { firstName: "ming", lastName: "li", username: "lm" },
  { firstName: "mingtao", lastName: "liu", username: "lmt" },
  { firstName: "rui", lastName: "sun", username: "rs" },
  { firstName: "haibo", lastName: "wang", username: "whb" },
  { firstName: "tiancheng", lastName: "wu", username: "wtc" },
  { firstName: "junyu", lastName: "yang", username: "yjy" },
  { firstName: "qiang", lastName: "zhang", username: "zq" },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_OP_List).reply(200, {
  data: fetch_OP_List,
});

// ── FA Tracker Mock Data ──────────────────────────────────────────────────────

import { IFADetail, IFALogEntry, IFATrackerSummary, INewFinding } from "@/type/axios";

// Project list
axiosMockAdapterInstance.onGet(apiConfig.fetch_FATracker_ProjectList).reply(200, {
  data: [
    { id: "Tungsten", name: "Tungsten" },
    { id: "Tablet-Spinel", name: "Tablet-Spinel" },
    { id: "Tablet-Turquoise", name: "Tablet-Turquoise" },
    { id: "Athena-Pro", name: "Athena-Pro" },
    { id: "Piezo-Ultra", name: "Piezo-Ultra" },
  ],
  isSuccess: true,
});

// Summary cards
const faTrackerSummary: IFATrackerSummary = {
  closeRate: 50,
  pendingCount: 3,
  overdueCount: 3,
  incompleteClosureCount: 0,
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_FATracker_Summary).reply(200, {
  data: faTrackerSummary,
  isSuccess: true,
});

// FA Log entries
const faLogEntries: IFALogEntry[] = [
  {
    id: 1,
    faCaseNo: "FA-0001",
    status: "IN_PROGRESS",
    jiraNumber: "https://issues.labcollab.net/browse/TUNGSTENHW-229",
    issueTestDescription: "#3424 - Standard Free Drop Test - GN - Lv1 (2F)\n#3424 - Lens Removal Insertion Test - Lv1 (1F)",
    buildIdentifier: "EVT-1.0",
    latestSummary: "Brittle fracture cases showed crack initiation at the inadequately fused interface, while ductile fracture patterns showed no interfacial degradation.",
    rootCause: null,
    correctiveActions: null,
    updatedTs: "2026-03-27T10:00:00Z",
  },
  {
    id: 2,
    faCaseNo: "FA-0002",
    status: "IN_PROGRESS",
    jiraNumber: "https://issues.labcollab.net/browse/TUNGSTENHW-305",
    issueTestDescription: "#3501 - Thermal Shock Test - Lv1 (1F)",
    buildIdentifier: "EVT-1.0",
    latestSummary: "Thermal cycling revealed minor swelling in battery cells under sustained high temperature conditions.",
    rootCause: null,
    correctiveActions: null,
    updatedTs: "2026-03-25T10:00:00Z",
  },
  {
    id: 3,
    faCaseNo: "FA-0003",
    status: "CLOSED",
    jiraNumber: "TUNGSTENHW-180",
    issueTestDescription: "#3100 - Pressure Test - Lv1 (1F)",
    buildIdentifier: "EVT-1.0",
    latestSummary: null,
    rootCause: "Insufficient wall thickness at corner radius leading to plastic deformation under sustained load.",
    correctiveActions: "Increased wall thickness from 0.8mm to 1.2mm at critical corner sections. Updated mold tooling.",
    updatedTs: "2026-03-10T10:00:00Z",
  },
  {
    id: 4,
    faCaseNo: "FA-0004",
    status: "CLOSED",
    jiraNumber: "TUNGSTENHW-195",
    issueTestDescription: "#3200 - Connector Insertion Test - Lv1 (2F)",
    buildIdentifier: "EVT-1.0",
    latestSummary: null,
    rootCause: "Pin retention force below spec due to plating thickness variation from supplier.",
    correctiveActions: "Tightened incoming QC spec for pin plating. Switched to backup supplier for connector module.",
    updatedTs: "2026-03-05T10:00:00Z",
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_FATracker_FALog).reply(200, {
  data: {
    items: faLogEntries,
    pagination: { page: 1, pageSize: 50, totalItems: 4, totalPages: 1 },
  },
  isSuccess: true,
});

// New Findings
const newFindings: INewFinding[] = [
  {
    id: 1,
    issueId: 3501,
    foundDate: "2026-03-20T00:00:00Z",
    issueDescription: "Hinge - Fatigue",
    testName: "Flex Fatigue Test - Lv1",
    dsn: "H1_007",
    buildIdentifier: "EVT-2.0",
    pendingDays: 12,
    isWaived: false,
    checkpoint: "Mechanical Endurance Lab",
  },
  {
    id: 2,
    issueId: 3502,
    foundDate: "2026-03-18T00:00:00Z",
    issueDescription: "Battery - Swelling",
    testName: "Thermal Shock Test - Lv1",
    dsn: "B2_003",
    buildIdentifier: "EVT-1.0",
    pendingDays: 14,
    isWaived: false,
    checkpoint: "Environmental Chamber B",
  },
  {
    id: 3,
    issueId: 3503,
    foundDate: "2026-03-15T00:00:00Z",
    issueDescription: "CG - Crack",
    testName: "Standard Free Drop Test - GN - Lv1",
    dsn: "D1_001",
    buildIdentifier: "EVT-1.0",
    pendingDays: 17,
    isWaived: false,
    checkpoint: "Drop Tower A",
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_FATracker_NewFindings).reply(200, {
  data: {
    items: newFindings,
    pagination: { page: 1, pageSize: 50, totalItems: 3, totalPages: 1 },
  },
  isSuccess: true,
});

// FA Detail (drawer)
const faDetailMap: Record<string, IFADetail> = {
  "1": {
    id: 1,
    faCaseNo: "FA-0001",
    status: "IN_PROGRESS",
    jiraNumber: "TUNGSTENHW-229",
    summary: "Brittle fracture cases showed crack initiation at the inadequately fused interface, while ductile fracture patterns showed no interfacial degradation.",
    rootCause: null,
    correctiveActions: null,
    createdBy: "jianyihp",
    createdTs: "2026-03-01T10:00:00Z",
    updatedTs: "2026-03-27T10:00:00Z",
    sampleGroups: [
      {
        testName: "Standard Free Drop Test - GN - Lv1",
        failureCount: 2,
        failureMode: "Crack",
        samples: [
          { id: 101, issueId: 3424, dsn: "D1_001", testSequenceId: 3424, label: "D1_001 - #3424" },
          { id: 102, issueId: 3424, dsn: "D1_002", testSequenceId: 3424, label: "D1_002 - #3424" },
        ],
      },
      {
        testName: "Lens Removal Insertion Test - Lv1",
        failureCount: 1,
        failureMode: "Delamination",
        samples: [{ id: 103, issueId: 3424, dsn: "D1_001", testSequenceId: 3424, label: "D1_001 - #3424" }],
      },
    ],
    history: [],
  },
  "2": {
    id: 2,
    faCaseNo: "FA-0002",
    status: "IN_PROGRESS",
    jiraNumber: "TUNGSTENHW-305",
    summary: "Thermal cycling revealed minor swelling in battery cells under sustained high temperature conditions.",
    rootCause: null,
    correctiveActions: null,
    createdBy: "jianyihp",
    createdTs: "2026-03-15T10:00:00Z",
    updatedTs: "2026-03-25T10:00:00Z",
    sampleGroups: [
      {
        testName: "Thermal Shock Test - Lv1",
        failureCount: 1,
        failureMode: "Swelling",
        samples: [{ id: 201, issueId: 3501, dsn: "B2_003", testSequenceId: 3501, label: "B2_003 - #3501" }],
      },
    ],
    history: [
      { id: 1, summary: "Thermal cycling revealed minor swelling in battery cells under sustained high temperature conditions.", createdTs: "2026-03-25T10:00:00Z" },
      { id: 2, summary: "Initial investigation started. Battery removed for cross-section analysis.", createdTs: "2026-03-20T10:00:00Z" },
    ],
  },
  "3": {
    id: 3,
    faCaseNo: "FA-0003",
    status: "CLOSED",
    jiraNumber: "TUNGSTENHW-180",
    summary: "Root cause confirmed. Corrective action implemented and verified.",
    rootCause: "Insufficient wall thickness at corner radius leading to plastic deformation under sustained load.",
    correctiveActions: "Increased wall thickness from 0.8mm to 1.2mm at critical corner sections. Updated mold tooling.",
    createdBy: "jianyihp",
    createdTs: "2026-02-20T10:00:00Z",
    updatedTs: "2026-03-10T10:00:00Z",
    sampleGroups: [
      {
        testName: "Pressure Test - Lv1",
        failureCount: 1,
        failureMode: "Deformation",
        samples: [{ id: 301, issueId: 3100, dsn: "C3_002", testSequenceId: 3100, label: "C3_002 - #3100" }],
      },
    ],
    history: [
      { id: 1, summary: "Root cause confirmed. Corrective action implemented and verified.", createdTs: "2026-03-10T10:00:00Z" },
      { id: 2, summary: "Cross-section analysis shows thinning at corner radius.", createdTs: "2026-03-05T10:00:00Z" },
      { id: 3, summary: "Initial failure report submitted.", createdTs: "2026-02-28T10:00:00Z" },
    ],
  },
  "4": {
    id: 4,
    faCaseNo: "FA-0004",
    status: "CLOSED",
    jiraNumber: "TUNGSTENHW-195",
    summary: "Corrective action validated. Supplier change completed.",
    rootCause: "Pin retention force below spec due to plating thickness variation from supplier.",
    correctiveActions: "Tightened incoming QC spec for pin plating. Switched to backup supplier for connector module.",
    createdBy: "ssdsd",
    createdTs: "2026-02-15T10:00:00Z",
    updatedTs: "2026-03-05T10:00:00Z",
    sampleGroups: [
      {
        testName: "Connector Insertion Test - Lv1",
        failureCount: 2,
        failureMode: "Retention failure",
        samples: [
          { id: 401, issueId: 3200, dsn: "E2_001", testSequenceId: 3200, label: "E2_001 - #3200" },
          { id: 402, issueId: 3200, dsn: "E2_004", testSequenceId: 3200, label: "E2_004 - #3200" },
        ],
      },
    ],
    history: [
      { id: 1, summary: "Corrective action validated. Supplier change completed.", createdTs: "2026-03-05T10:00:00Z" },
      { id: 2, summary: "Root cause: plating thickness variation from supplier.", createdTs: "2026-02-25T10:00:00Z" },
      { id: 3, summary: "Pin retention force measurement below spec on 2 units.", createdTs: "2026-02-20T10:00:00Z" },
    ],
  },
};

axiosMockAdapterInstance.onGet(apiConfig.fetch_FATracker_FADetail).reply(config => {
  const faCaseId = config.params?.faCaseId as string | undefined;
  const detail = faCaseId ? faDetailMap[faCaseId] : undefined;
  if (!detail) {
    return [400, { isSuccess: false, code: "400", message: "FA case not found." }];
  }
  return [200, { data: detail, isSuccess: true }];
});

// Write operations
axiosMockAdapterInstance.onPost(apiConfig.update_FATracker_FADetail).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "FA detail updated successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.update_FATracker_UpdateAll).reply(200, {
  data: { success: true, updatedCount: 2 },
  isSuccess: true,
  message: "All FA cases updated successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.create_FATracker_FA).reply(200, {
  data: { success: true, caseNo: "FA-0005" },
  isSuccess: true,
  message: "FA case created successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.create_FATracker_MarkWaived).reply(200, {
  data: { success: true },
  isSuccess: true,
  message: "Finding marked as waived",
});

axiosMockAdapterInstance.onPost(apiConfig.unlink_FATracker_Finding).reply(200, { isSuccess: true, code: 200, message: null });

axiosMockAdapterInstance.onPost(apiConfig.batch_FATracker_SmartSummary).reply(config => {
  const body = JSON.parse(config.data);
  const items = body.items ?? [];
  const results = items.map((item: any) => ({
    faCaseId: item.faCaseId,
    summary: item.faStatus === "IN_PROGRESS" ? `AI summary for ${item.faCaseId}: Investigation ongoing. Thermal stress patterns identified at bonding interface from JIRA analysis.` : null,
    rootCause: item.faStatus === "CLOSED" ? `Root cause for ${item.faCaseId}: Material fatigue under cyclic loading.` : null,
    correctiveActions: item.faStatus === "CLOSED" ? "Updated material spec and supplier QC." : null,
    error: null,
  }));
  return [200, { data: { results }, isSuccess: true, message: "Batch smart summary generated" }];
});

axiosMockAdapterInstance.onGet(apiConfig.fetch_FATracker_SmartSummary).reply(200, {
  data: {
    jiraInfo: {
      issueKey: "TUNGSTENHW-229",
      summary: "Brittle fracture at fused interface in drop test samples",
      description: "Multiple samples showed crack initiation at inadequately fused interface during standard free drop test.",
      status: "In Progress",
      assignee: "sankermo",
      reporter: "jianyihp",
      jiraUrl: "https://issues.labcollab.net/browse/TUNGSTENHW-229",
    },
    summary:
      "Cross-section microscopy revealed brittle fracture initiation at the fused interface boundary. The crack propagated along grain boundaries indicating insufficient fusion energy during the welding process. No evidence of material contamination or pre-existing defects was found.",
    rootCause: null,
    correctiveActions: null,
  },
  isSuccess: true,
  message: "Smart summary generated",
});

// ───────────────────────────────────────────────────────────────────────────
// DataOverview mock — mirrors the PM mockup distribution (~80–200 devices)
// ───────────────────────────────────────────────────────────────────────────

// Deterministic Status-column coverage fixtures. Prepended to the top of the list
// so every status × reviewState combination is visible without scrolling. The Status
// column renders two tags side-by-side: StatusPill (status) + ReviewBadge (review),
// and the ReviewBadge ("To Review" / "Approved") only appears for completed statuses.
// These rows exist specifically to manually check the two-tag clipping bug.
function _genDataOverviewStatusFixtures(): IDataOverviewDevice[] {
  const fullProgress: IDataOverviewProgress = { completed: 120, total: 120 };
  const partialProgress: IDataOverviewProgress = { completed: 42, total: 120 };
  const emptyProgress: IDataOverviewProgress = { completed: 0, total: 120 };

  // [label, BE status, hasCmApproved, isOverdue, progress] — covers single-tag and two-tag cases.
  const cases: [string, TDataOverviewBeStatus, boolean, boolean, IDataOverviewProgress][] = [
    // Single-tag (no ReviewBadge): non-completed statuses.
    ["STATUS_NotStarted", "NOT_STARTED", false, false, emptyProgress],
    ["STATUS_Queued", "queued", false, false, emptyProgress],
    ["STATUS_Ongoing", "ONGOING", false, false, partialProgress],
    ["STATUS_Ongoing_Overdue", "ongoing", false, true, partialProgress],
    ["STATUS_Cancelled", "CANCELLED", false, false, emptyProgress],
    // Two-tag: completed statuses × review state (this is where clipping shows).
    ["STATUS_Pass_ToReview", "COMPLETED", false, false, fullProgress],
    ["STATUS_Pass_Approved", "COMPLETED", true, false, fullProgress],
    ["STATUS_Fail_ToReview", "fail", false, false, fullProgress],
    ["STATUS_Fail_Approved", "fail", true, false, fullProgress],
    ["STATUS_Observation_ToReview", "OBSERVATION", false, false, fullProgress],
    ["STATUS_Observation_Approved", "OBSERVATION", true, false, fullProgress],
  ];

  return cases.map(([label, status, hasCmApproved, isOverdue, progress], i) => ({
    dsn: `AUCC_HYPNOS_DVT_1-DOT-0_${label}`,
    realDsn: `G${String(i + 1).padStart(16, "0")}`,
    deviceDisplayName: label,
    configName: "D1F-BLK2",
    sequenceId: "DEFAULT",
    status,
    hasCmApproved,
    completedDate: "2026-05-19",
    hasAllMajorReadoutDates: true,
    isOverdue,
    overallProgress: progress,
    checkProgress: progress,
    fatpProgress: progress,
    measurementProgress: progress,
    variableProgress: progress,
  }));
}

function _genDataOverviewMock(): IDataOverviewDevice[] {
  const configs = ["D1F-BLK2", "D1F-WHT", "D2F-BLK", "D2F-WHT"];
  const sequences = ["DEFAULT", "Sequence A", "Sequence B"];
  // "OBSERVATION" is uppercase on purpose — BE's observation-override path emits the literal, not
  // the lowercase enum value; keeping it here exercises the normalizer's uppercase handling (1216775380281396).
  const statuses: TDataOverviewBeStatus[] = ["NOT_STARTED", "ONGOING", "COMPLETED", "CANCELLED", "OBSERVATION"];
  const weights = [0.15, 0.35, 0.3, 0.1, 0.1];
  const today = new Date("2026-05-19");
  const total = 80 + Math.floor(Math.random() * 120);
  const counters: Record<string, number> = {};
  const out: IDataOverviewDevice[] = [];

  for (let i = 0; i < total; i++) {
    const config = configs[i % configs.length];
    counters[config] = (counters[config] ?? 0) + 1;
    const display = `${config}_${String(counters[config]).padStart(3, "0")}`;
    const r = Math.random();
    let acc = 0;
    let status: TDataOverviewBeStatus = "ONGOING";
    for (let s = 0; s < statuses.length; s++) {
      acc += weights[s];
      if (r <= acc) {
        status = statuses[s];
        break;
      }
    }
    const etaOffset = Math.floor(Math.random() * 40) - 10;
    const eta = new Date(today);
    eta.setDate(eta.getDate() + etaOffset);
    const completedDate = `${eta.getFullYear()}-${String(eta.getMonth() + 1).padStart(2, "0")}-${String(eta.getDate()).padStart(2, "0")}`;
    const isOverdue = eta < today && status !== "COMPLETED" && status !== "CANCELLED" && status !== "OBSERVATION";
    const ckTotal = 30 + Math.floor(Math.random() * 200);
    const fpTotal = 4 + Math.floor(Math.random() * 12);
    const msTotal = 5 + Math.floor(Math.random() * 90);
    const vrTotal = 4 + Math.floor(Math.random() * 36);
    const ovTotal = 10 + Math.floor(Math.random() * 200);
    const filledRatio = status === "COMPLETED" || status === "OBSERVATION" ? 1 : status === "ONGOING" ? 0.05 + Math.random() * 0.85 : 0;
    const sub = (t: number) => Math.floor(t * filledRatio * (0.8 + Math.random() * 0.2));
    out.push({
      dsn: `AUCC_HYPNOS_DVT_1-DOT-0_${display}`,
      realDsn: `G${Math.floor(Math.random() * 1e16)
        .toString()
        .padStart(16, "0")}`,
      deviceDisplayName: display,
      configName: config,
      sequenceId: sequences[Math.floor(Math.random() * sequences.length)],
      status,
      hasCmApproved: status === "COMPLETED" && Math.random() < 0.55,
      completedDate,
      hasAllMajorReadoutDates: Math.random() > 0.25,
      isOverdue,
      overallProgress: { completed: sub(ovTotal), total: ovTotal },
      checkProgress: { completed: sub(ckTotal), total: ckTotal },
      fatpProgress: { completed: sub(fpTotal), total: fpTotal },
      measurementProgress: { completed: sub(msTotal), total: msTotal },
      variableProgress: { completed: sub(vrTotal), total: vrTotal },
    });
  }
  return out;
}

axiosMockAdapterInstance.onGet(apiConfig.fetch_DataOverview_List).reply(() => {
  // Deterministic Status-column coverage fixtures first, then the randomized volume.
  return [200, { code: 200, isSuccess: true, data: [..._genDataOverviewStatusFixtures(), ..._genDataOverviewMock()] }];
});

// =====================================================================
// DataOverview Phase 2 mocks
// =====================================================================

function _genReadoutListMock(): IReadoutListItem[] {
  // 30 readouts; readouts 27, 54, 81 are tagged as major checkpoints; 81 is the final one.
  const items: IReadoutListItem[] = [];
  for (let order = 1; order <= 30; order++) {
    const isMajor = order === 27 || order === 54 || order === 81;
    items.push({
      id: 700000 + order,
      order,
      keyValuePair: [
        { key: "Voltage", value: order % 2 === 0 ? "+8kV" : "-8kV" },
        { key: "Location", value: `L${(order % 27) + 1}` },
        { key: "zaps", value: "10" },
      ],
      isMajorCheckpoint: isMajor,
      milestoneLabel: isMajor ? `Checkpoint #${order}` : undefined,
    });
  }
  return items;
}

function _genVariableSelectionsMock(): ITestVariableSelection[] {
  return [
    { key: "SW_VERSION", name: "SW Version", values: ["Diag Image", "User Image"] },
    { key: "CHARGER", name: "Charger Connected", values: ["Yes", "No"] },
    { key: "MUSIC", name: "Music Playback", values: ["Bluetooth", "WiFi"] },
  ];
}

// get_major_readout_list — major checkpoints (27, 54) plus the final readout (81),
// each carrying its scheduled `date` (81 left blank to exercise the "fill in" UI).
// Mirrors the rows _genReadoutListMock tags as major.
function _genMajorReadoutListMock(): IMajorReadoutItem[] {
  return [
    {
      id: 700027,
      order: 27,
      isMajorReadout: true,
      date: "2026-04-25",
      keyValuePair: [
        { key: "Voltage", value: "-8kV" },
        { key: "Location", value: "L1" },
      ],
    },
    {
      id: 700054,
      order: 54,
      isMajorReadout: true,
      date: "2026-04-28",
      keyValuePair: [
        { key: "Voltage", value: "+8kV" },
        { key: "Location", value: "L28" },
      ],
    },
    {
      id: 700081,
      order: 81,
      isMajorReadout: true,
      keyValuePair: [
        { key: "Voltage", value: "-8kV" },
        { key: "Location", value: "L1" },
      ],
    },
  ];
}

const mockReadoutList: IReadoutListItem[] = _genReadoutListMock();

axiosMockAdapterInstance.onGet(apiConfig.fetch_DataOverview_ReadoutList).reply(config => {
  const stationId = config.params?.stationId as string | undefined;
  let data: IReadoutListItem[] = mockReadoutList;
  if (stationId) {
    // Approximation: only major-checkpoint readouts have FATP stations available.
    data = data.filter(r => r.isMajorCheckpoint);
  }
  return [200, { code: 200, isSuccess: true, message: "", data }];
});
axiosMockAdapterInstance.onGet(apiConfig.fetch_DataOverview_TestVariableSelections).reply(() => {
  return [200, { code: 200, isSuccess: true, data: _genVariableSelectionsMock() }];
});
axiosMockAdapterInstance.onGet(apiConfig.fetch_DataOverview_MajorReadoutList).reply(() => {
  return [200, { code: 200, isSuccess: true, data: _genMajorReadoutListMock() }];
});

// ── FATP Log Link mocks (genealogy-based) ────────────────────────────
// The "station" dropdown is fed by /get_fatp_checks (shared with fetch_Station_List,
// mocked below). Genealogy records come from /get_batch_fatp_genealogy, and the
// mapping is saved via /save_batch_fatp_mapping.
const FATP_STATIONS = ["AFT", "ARF", "AUT", "MT", "MIC_SEAL"];

function fatpHash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

// Deterministic per-DSN genealogy. Bucket by hash % 10 so the drawer sees a mix of
// skipped (no records), single-record (auto-picked), and multi-record devices,
// with a sprinkling of failures to exercise the batch-issue path.
function genealogyForDsn(dsn: string): IFatpGenealogyItem[] {
  const base = fatpHash(dsn);
  function record(salt: number, pass: boolean, hour: number): IFatpGenealogyItem {
    const suffix = String((base + salt * 7919) % 1_000_000).padStart(6, "0");
    return {
      serialId: `${dsn}-${suffix}`,
      startTime: `2026-01-31T${String(hour).padStart(2, "0")}:00:00`,
      testResult: pass ? "PASS" : "FAIL",
      errorCode: pass ? "" : `E${String((base + salt) % 1000).padStart(3, "0")}`,
      process: `PROC_${(base + salt) % 5}`,
      station: FATP_STATIONS[(base + salt) % FATP_STATIONS.length],
    };
  }
  const bucket = base % 10;
  if (bucket <= 1) return []; // skipped
  if (bucket <= 4) return [record(1, true, 8)]; // single PASS (auto-picked)
  if (bucket === 5) return [record(2, false, 9)]; // single FAIL
  if (bucket <= 7) return [record(3, true, 10), record(4, false, 11)];
  return [record(5, true, 8), record(6, true, 10), record(7, false, 12)];
}

axiosMockAdapterInstance.onPost(apiConfig.search_DataOverview_FATPLogs).reply(config => {
  const body = JSON.parse(config.data ?? "{}") as TFATPGenealogyRequest;
  const dsns: string[] = body.dsns ?? [];
  const data: IBatchFatpGenealogyDevice[] = dsns.map(dsn => ({
    dsn,
    shortId: dsn.slice(-4),
    fatp: genealogyForDsn(dsn),
  }));
  return [200, { isSuccess: true, message: "", data }];
});

axiosMockAdapterInstance.onPost(apiConfig.batch_DataOverview_LinkFATPLogs).reply(200, {
  isSuccess: true,
  message: "FATP mapping saved",
  data: null,
});

[
  apiConfig.batch_DataOverview_MarkOngoing,
  apiConfig.batch_DataOverview_MarkCompleted,
  apiConfig.batch_DataOverview_Reset,
  apiConfig.batch_DataOverview_Approve,
  apiConfig.batch_DataOverview_PassReadouts,
  apiConfig.batch_DataOverview_SetVariables,
  apiConfig.change_DataOverview_ReadoutSchedule,
  apiConfig.update_DataOverview_TestStatus,
].forEach(url => {
  axiosMockAdapterInstance.onPost(url).reply(() => {
    return [200, { code: 200, isSuccess: true, message: "ok", data: null }];
  });
});

// ─── FATPViewer ─────────────────────────────────────────────────────────
const fatpViewer_StationList: TIdentifier[] = [
  { key: "AUT_USER", name: "AUT_USER" },
  { key: "ARF", name: "ARF" },
  { key: "Mic Seal", name: "Mic Seal" },
  { key: "ADT", name: "ADT" },
  { key: "CAMERA IQ", name: "CAMERA IQ" },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_Station_List).reply(200, {
  data: fatpViewer_StationList,
});

const fatpViewer_Configs: IFATPConfigItem[] = [
  ...Array.from({ length: 12 }, (_, i) => ({ config: "CFG1", dsn: `AUCC_CFG1_${String(i + 1).padStart(3, "0")}`, shortId: String(i + 1).padStart(3, "0"), order: i + 1 })),
  ...Array.from({ length: 8 }, (_, i) => ({ config: "CFG2", dsn: `AUCC_CFG2_${String(i + 1).padStart(3, "0")}`, shortId: String(i + 1).padStart(3, "0"), order: i + 1 })),
];
axiosMockAdapterInstance.onPost(apiConfig.fetch_FATPViewer_DeviceBuckets).reply(200, { isSuccess: true, code: 200, data: fatpViewer_Configs });

const fatpViewer_Parameters: IFATPParameterItem[] = [
  { parameter: "bt_ble_rx1_2402_1le_ber@-93dbm", count: 20, type: "SEQUENCE PARAMETERS" },
  { parameter: "bt_ble_rx1_2442_1le_ber@-93dbm", count: 20, type: "SEQUENCE PARAMETERS" },
  { parameter: "bt_ble_rx1_2480_1le_ber@-93dbm", count: 20, type: "SEQUENCE PARAMETERS" },
  { parameter: "battery_voltage_idle", count: 20, type: "INDEPENDENT NUMERIC PARAMETERS" },
  { parameter: "peak_current", count: 20, type: "INDEPENDENT NUMERIC PARAMETERS" },
  { parameter: "firmware_version", count: 20, type: "NON-NUMERIC" },
];
axiosMockAdapterInstance.onPost(apiConfig.fetch_FATPViewer_Parameters).reply(200, { isSuccess: true, code: 200, data: fatpViewer_Parameters });

// Per-parameter shape used by the StationData mock. Limits are deliberately set so the
// generator's spread occasionally pokes through them — that lets the chart's Max/Min lines
// land between the data and the limit dashes, instead of stacking on top of each other.
interface IMockParamShape {
  upperLimit: number;
  lowerLimit: number;
  units: string;
  // Centerline at sweep index i (0-based). Lets sequence params curve across the sweep.
  baseAt: (sweepIdx: number) => number; // eslint-disable-line no-unused-vars
  // Per-device spread; output is added to baseAt. Mostly inside (lower, upper).
  spread: number;
  // Per-readout drift — readout 0 is the "T0" baseline, later readouts pull the centerline.
  readoutDrift: number;
}

function paramShape(name: string): IMockParamShape {
  // bt_ble_rx1_<n>_1le_ber@-93dbm — BER %, low values, occasional spikes
  if (name.includes("ber")) {
    return {
      upperLimit: 12,
      lowerLimit: 0,
      units: "%",
      baseAt: i => 3 + i * 0.4, // 3, 3.4, 3.8 across the 3 sweep points
      spread: 7, // peaks in the 8-10 range, occasional outlier > upper
      readoutDrift: 1.2, // BER tends to climb after stress
    };
  }
  // bt_ble_tx1_<n>_power_avg — TX power dBm, limit window ~[6, 11]
  if (name.includes("power_avg")) {
    return {
      upperLimit: 11,
      lowerLimit: 6,
      units: "dBm",
      baseAt: i => 8.5 - i * 0.15, // mild rolloff across sweep
      spread: 2.6,
      readoutDrift: -0.4,
    };
  }
  // battery_voltage_idle — V, narrow window
  if (name === "battery_voltage_idle") {
    return {
      upperLimit: 4.2,
      lowerLimit: 3.6,
      units: "V",
      baseAt: () => 3.95,
      spread: 0.35, // crosses both limits at the tails
      readoutDrift: -0.05,
    };
  }
  // final_resistance — Ω, mild distribution
  if (name === "final_resistance") {
    return {
      upperLimit: 28,
      lowerLimit: 18,
      units: "Ω",
      baseAt: () => 23,
      spread: 5.5,
      readoutDrift: 0.8,
    };
  }
  // peak_current — A
  if (name === "peak_current") {
    return {
      upperLimit: 2.4,
      lowerLimit: 0.8,
      units: "A",
      baseAt: () => 1.6,
      spread: 0.95,
      readoutDrift: 0.1,
    };
  }
  // Fallback for anything new — wide window so limits don't crowd the data.
  return { upperLimit: 30, lowerLimit: 0, units: "", baseAt: () => 15, spread: 6, readoutDrift: 0.5 };
}

// Stable pseudo-random in [0, 1). Lets the mock be deterministic across reloads (otherwise
// each Generate produces a different Max/Min and you can't compare consecutive screenshots).
function rng(seed: number): number {
  const x = Math.sin(seed * 12.9898 + 78.233) * 43758.5453;
  return x - Math.floor(x);
}

axiosMockAdapterInstance.onPost(apiConfig.fetch_FATPViewer_StationData).reply(config => {
  const body = JSON.parse(config.data ?? "{}") as { testReadoutIds?: number[]; dsns?: string[]; parameters?: { name: string; type: string }[] };
  const readoutIds = body.testReadoutIds?.length ? body.testReadoutIds : [1001, 1002, 1003];
  const dsns = body.dsns?.length ? body.dsns : ["DSN_001", "DSN_002", "DSN_003", "DSN_004", "DSN_005"];
  const params = body.parameters ?? [];

  const data: IFATPParameterDataGroup[] = params.map(({ name }) => {
    const shape = paramShape(name);
    // Generate a realistic sweep of x-values for sequence parameters (8 frequency points)
    const sweep = /_(\d{3,5})/.exec(name);
    const xVals = sweep ? [2400, 2410, 2420, 2430, 2440, 2450, 2460, 2470] : Array.from({ length: 8 }, (_, i) => i);
    const points: IFATPDataSeries[] = [];
    readoutIds.forEach((rid, ri) => {
      dsns.forEach((dsn, di) => {
        const y = xVals.map((_, xi) => +(shape.baseAt(xi) + ri * shape.readoutDrift + (rng(di * 7 + ri * 31 + xi * 13 + name.length) - 0.5) * shape.spread).toFixed(3));
        points.push({ type: "DEFAULT", testReadoutId: rid, readoutKey: "time (hrs)", readoutValue: `${ri * 72}`, config: "CFG1", dsn, shortId: dsn.slice(-3), x: xVals, y });
      });
    });
    points.push({ type: "UPPER_LIMIT", x: xVals, y: xVals.map(() => shape.upperLimit) });
    points.push({ type: "LOWER_LIMIT", x: xVals, y: xVals.map(() => shape.lowerLimit) });
    // Per-device BASELINE (T0) series — each device carries its own T0, distinct from any DEFAULT
    // readout. Centered on the parameter's baseAt curve with a small per-device offset so the
    // dashed baseline lines fan out slightly and delta mode zeroes each device against its own T0.
    dsns.forEach((dsn, di) => {
      const y = xVals.map((_, xi) => +(shape.baseAt(xi) + (rng(di * 5 + xi * 11 + name.length + 101) - 0.5) * shape.spread * 0.3).toFixed(3));
      points.push({ type: "BASELINE", config: "CFG1", dsn, shortId: dsn.slice(-3), x: xVals, y });
    });
    return { parameter: name, points };
  });

  return [200, { isSuccess: true, code: 200, data }];
});

// ─── FATPViewer raw parameter export (async submit-then-poll) ───────────
//
// The whole point of these two fixtures is the TIMING, not the payload. Every number below was
// measured against real data on a 34-device selection, and two of them look like bugs if you
// have not seen them before:
//
//   1. There is a ~25 SECOND silence between "Fetching parameters for N log(s)" and the first
//      "Fetched 25000 rows" — Athena spends that long planning the query before it returns a
//      single row. A mock that skipped it would make real behaviour look like a hung poll.
//   2. The whole job takes ~70s, which is past the 60s ALB idle timeout. That is why this is a
//      job rather than a request, so a mock that finished in 2s would hide the reason the
//      feature is shaped this way.
//
// Set TIMELINE_SCALE to something like 0.1 while iterating on layout, then put it back to 1
// before judging whether the progress UI actually reads well.
const MOCK_RAW_EXPORT_TIMELINE_SCALE = 1;

// Flip to true to develop the error path — the job then fails partway through with a
// user-facing message, exactly as a FAILED status arrives from the BE.
const MOCK_RAW_EXPORT_SHOULD_FAIL = false;

const MOCK_RAW_EXPORT_ROW_COUNT = 274617; // measured: 34 devices × 1 readout on station `aut`
const MOCK_RAW_EXPORT_GAP_LOG_COUNT = 0; // was 0 in every alpha run; set >0 to exercise the note
const MOCK_RAW_EXPORT_LOG_COUNT = 34;
const MOCK_RAW_EXPORT_ROWS_PER_SEC = 8600; // 274,617 rows in ~32s of paging
const MOCK_RAW_EXPORT_ROW_REPORT_STEP = 25000; // the BE reports progress every 25k rows

// Phase boundaries in ms from submission, before scaling.
const MOCK_RAW_EXPORT_QUEUED_UNTIL = 2000;
const MOCK_RAW_EXPORT_RESOLVING_UNTIL = 5000;
const MOCK_RAW_EXPORT_PLANNING_UNTIL = 30000; // ← the silent Athena planning gap ends here
const MOCK_RAW_EXPORT_FETCH_UNTIL = MOCK_RAW_EXPORT_PLANNING_UNTIL + (MOCK_RAW_EXPORT_ROW_COUNT / MOCK_RAW_EXPORT_ROWS_PER_SEC) * 1000;
const MOCK_RAW_EXPORT_UPLOAD_UNTIL = MOCK_RAW_EXPORT_FETCH_UNTIL + 6000;
const MOCK_RAW_EXPORT_FAIL_AT = 12000; // when OUTCOME is "fail", it fails during the fetch phase

interface IMockRawExportJob {
  startedAt: number;
  logCount: number;
  /** Lazily built on first SUCCEEDED poll so the mock download produces a real file offline. */
  downloadUrl?: string;
}

const mockRawExportJobs = new Map<string, IMockRawExportJob>();

/**
 * A tiny but structurally faithful stand-in for the real CSV: 13 columns in the frozen order,
 * long format, UTF-8 BOM, and values that exercise the awkward cases the BE passes through
 * verbatim. Enough to check that whatever opens the file copes; not enough to be mistaken for
 * the real export.
 *
 * Written as one template literal so the fixture reads as the bytes it produces, quoted fields
 * included, rather than hidden behind per-row escaping.
 *
 * What each row proves:
 *   1. an ordinary numeric value with limits
 *   2. the literal `empty` survives — it means "recorded, no value", NOT missing
 *   3. the literal `NA` unit survives
 *   4. a non-ASCII unit renders (this is what the BOM is for)
 *   5. a value carrying BOTH a newline and a comma — the pair a naive join corrupts, so it is
 *      RFC 4180 quoted; taken from a real measured value
 *   6. `N/A`, which — unlike `empty` — does mean no row existed at all
 *
 * Line endings are LF here, where the real export uses CRLF. That difference does not matter to
 * anything the FE does with the file, and writing CRLF as `\r` plus a source newline would break
 * the moment the file was checked out with CRLF endings. Do not read this fixture as a spec for
 * the real export's line endings.
 */
const MOCK_RAW_EXPORT_CSV_BODY = `Real DSN,Device,Test,Readout,start_time,station,test_result,Errorcode,Upperlimit,Lowerlimit,Units,parameter_name,parameter_value
G0B0GU035185000E,013,ESD Contact Discharge - L1,#82 voltage: +8kV,20251107_103816,aut,pass,,7,6,Kgf.cm,screw_result.1_torquekgf.cm,6.42
G0B0GU035185000E,013,ESD Contact Discharge - L1,#82 voltage: +8kV,20251107_103816,aut,pass,ErrorCode-005,500,400,RPM,screw_result.1_speedmax,empty
G0B0GU035185000E,013,ESD Contact Discharge - L1,#82 voltage: +8kV,20251107_103816,aut,pass,,,,NA,getsn,g0b0gu035185000e
G0B0GU035185000E,013,ESD Contact Discharge - L1,#82 voltage: +8kV,20251107_103816,aut,pass,,,,\u05EA/min,fan_speed,1820
G0B0GU035185000F,014,ESD Contact Discharge - L1,#82 voltage: +8kV,20251107_104512,aut,fail,,,,,boot_log,"REBOOTING OKAY [ 0.002S]
FINISHED, TOTAL TIME: 0.002S"
G0B0GU035185000F,014,ESD Contact Discharge - L1,#82 voltage: +8kV,20251107_104512,aut,fail,,,,,missing_parameter,N/A
`;

function buildMockRawExportCsv(): string {
  // The leading \ufeff is the UTF-8 BOM, written as an escape rather than a literal so it cannot
  // be lost to a copy-paste or read as stray whitespace. Without it Excel renders the non-ASCII
  // unit above as mojibake — the real BE writes the same BOM for the same reason.
  return `\ufeff${MOCK_RAW_EXPORT_CSV_BODY}`;
}

function mockRawExportDownloadUrl(job: IMockRawExportJob): string {
  // Built here rather than at module scope: URL.createObjectURL only exists in a browser, and
  // this file is imported by src/index.tsx alone, but the handler is the safer place regardless.
  job.downloadUrl ??= URL.createObjectURL(new Blob([buildMockRawExportCsv()], { type: "text/csv;charset=utf-8" }));
  return job.downloadUrl;
}

axiosMockAdapterInstance.onPost(apiConfig.start_FATPViewer_RawExport).reply(config => {
  const body = JSON.parse(config.data ?? "{}") as { dsns?: string[]; testReadoutIds?: number[] };
  const dsns = body.dsns ?? [];
  const readoutIds = body.testReadoutIds ?? [];

  // Mirror the server-side validation so the FE's own guards are checked against the same
  // messages the BE sends, rather than only against the happy path.
  if (dsns.length === 0) return [200, { isSuccess: false, code: 400, message: "Please select at least one device to export." }];
  if (readoutIds.length === 0) return [200, { isSuccess: false, code: 400, message: "Please select at least one readout to export." }];
  if (dsns.length > 200) return [200, { isSuccess: false, code: 400, message: `Please select at most 200 devices per export; ${dsns.length} were requested.` }];

  const jobId = `mock-${Date.now().toString(36)}`;
  mockRawExportJobs.set(jobId, { startedAt: Date.now(), logCount: Math.max(dsns.length * readoutIds.length, MOCK_RAW_EXPORT_LOG_COUNT) });
  return [200, { isSuccess: true, code: 200, data: { jobId, state: "QUEUED", queuePosition: 0 } }];
});

axiosMockAdapterInstance.onGet(apiConfig.fetch_FATPViewer_RawExportStatus).reply(config => {
  const jobId = String(config.params?.jobId ?? "");
  const job = mockRawExportJobs.get(jobId);
  // Same envelope the BE returns for an unknown or someone else's job. The polling loop must
  // stop rather than retry on this.
  if (!job) return [200, { isSuccess: false, code: 404, message: "No such export job." }];

  const elapsed = (Date.now() - job.startedAt) / MOCK_RAW_EXPORT_TIMELINE_SCALE;
  const at = (state: string, progress: string, extra: Record<string, unknown> = {}) => [200, { isSuccess: true, code: 200, data: { jobId, state, progress, ...extra } }] as [number, unknown];

  if (MOCK_RAW_EXPORT_SHOULD_FAIL && elapsed >= MOCK_RAW_EXPORT_FAIL_AT) {
    return at("FAILED", "Failed", { message: "No FATP data found for the selected check, devices and readouts." });
  }
  if (elapsed < MOCK_RAW_EXPORT_QUEUED_UNTIL) return at("QUEUED", "Queued");
  if (elapsed < MOCK_RAW_EXPORT_RESOLVING_UNTIL) return at("RUNNING", "Resolving logs");
  // The silent stretch. No row counts yet — Athena is still planning.
  if (elapsed < MOCK_RAW_EXPORT_PLANNING_UNTIL) return at("RUNNING", `Fetching parameters for ${job.logCount} log(s)`);
  if (elapsed < MOCK_RAW_EXPORT_FETCH_UNTIL) {
    const fetched = ((elapsed - MOCK_RAW_EXPORT_PLANNING_UNTIL) / 1000) * MOCK_RAW_EXPORT_ROWS_PER_SEC;
    const reported = Math.floor(fetched / MOCK_RAW_EXPORT_ROW_REPORT_STEP) * MOCK_RAW_EXPORT_ROW_REPORT_STEP;
    // Below the first 25k step the BE has nothing new to report, so it still says "Fetching".
    if (reported === 0) return at("RUNNING", `Fetching parameters for ${job.logCount} log(s)`);
    return at("RUNNING", `Fetched ${reported} rows`);
  }
  if (elapsed < MOCK_RAW_EXPORT_UPLOAD_UNTIL) return at("RUNNING", "Uploading", { rowCount: MOCK_RAW_EXPORT_ROW_COUNT });
  return at("SUCCEEDED", "Complete", {
    downloadUrl: mockRawExportDownloadUrl(job),
    rowCount: MOCK_RAW_EXPORT_ROW_COUNT,
    gapLogCount: MOCK_RAW_EXPORT_GAP_LOG_COUNT,
  });
});

// get_readouts_with_fatp_check returns the readouts already nested as a test/sequence →
// readouts tree (IFATPViewerReadoutTreeTest[]); the service wraps it into { tests } for the
// panels. Each readout is a BE FatpReadoutItem ({ id, order, keyValuePairs }).
const fatpViewer_ReadoutTree: IFATPViewerReadoutTreeTest[] = [
  {
    testId: "t-esd",
    testName: "ESD Contact Discharge",
    sequenceId: "1",
    readouts: [
      { id: 1002, order: 82, keyValuePairs: [{ key: "voltage", value: "+8kV" }] },
      { id: 1003, order: 162, keyValuePairs: [{ key: "voltage", value: "-12kV" }] },
    ],
  },
  {
    testId: "t-drop",
    testName: "Standard Free Drop",
    sequenceId: "2",
    readouts: [
      { id: 2002, order: 27, keyValuePairs: [{ key: "orientation", value: "Face-Down" }] },
      { id: 2003, order: 54, keyValuePairs: [{ key: "orientation", value: "Edge" }] },
    ],
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_FATPViewer_ReadoutTree).reply(200, {
  data: fatpViewer_ReadoutTree,
});

// get_fatp_readouts (DataOverview FATP Log Link drawer) returns check-filtered readouts
// already grouped: each row carries its own `keyValuePairs`. The service maps them 1:1 to
// IReadoutListItem (renaming keyValuePairs → keyValuePair). Mirrors the live alpha shape.
const fatp_readouts: IFatpReadoutOption[] = [
  {
    id: 2648900,
    order: 34,
    keyValuePairs: [
      { key: "Voltage", value: "+8kV" },
      { key: "Location", value: "L15" },
      { key: "Number Of Zaps", value: "10" },
    ],
  },
  {
    id: 2648934,
    order: 68,
    keyValuePairs: [
      { key: "Voltage", value: "-8kV" },
      { key: "Location", value: "L15" },
      { key: "Number Of Zaps", value: "10" },
    ],
  },
  {
    id: 2648968,
    order: 102,
    keyValuePairs: [
      { key: "Voltage", value: "+10kV" },
      { key: "Location", value: "L15" },
      { key: "Number Of Zaps", value: "10" },
    ],
  },
  {
    id: 2649002,
    order: 136,
    keyValuePairs: [
      { key: "Voltage", value: "-10kV" },
      { key: "Location", value: "L15" },
      { key: "Number Of Zaps", value: "10" },
    ],
  },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_DataOverview_FATPReadouts).reply(200, {
  isSuccess: true,
  code: 200,
  data: fatp_readouts,
});

// ── Issue List ────────────────────────────────────────────────────────────────
import { IIssueForCopy } from "@/type/axios";

const issueListStore: IIssueListItem[] = [
  {
    issueId: 3314,
    failureMode: "ADT Station - Fail",
    failingComponent: "Device",
    location: "ADT",
    recovery: "Non-Recoverable",
    recoverySteps: "",
    severity: "Failure",
    category: "FATP",
    translation: { zh: "ADT Station Fail" },
    isMappedWithChecks: false,
  },
  {
    issueId: 3268,
    failureMode: "Device - Can't boot up normally",
    failingComponent: "Device",
    location: "Boot",
    recovery: "Non-Recoverable",
    recoverySteps: "",
    severity: "Failure",
    category: "Functional",
    translation: { zh: "设备无法正常启动" },
    isMappedWithChecks: false,
  },
  {
    issueId: 3256,
    failureMode: "Display - Black",
    failingComponent: "Device",
    location: "Display",
    recovery: "Requires User Intervention",
    recoverySteps: "Press mute button",
    severity: "Failure",
    category: "Functional",
    translation: { zh: "显示屏黑屏（按静音键恢复）" },
    isMappedWithChecks: false,
  },
  {
    issueId: 3139,
    failureMode: "Display - Flash",
    failingComponent: "Device",
    location: "Display",
    recovery: "Self-Recoverable",
    recoverySteps: "",
    severity: "Observation",
    category: "Functional",
    translation: { zh: "显示屏闪烁（自动恢复）" },
    isMappedWithChecks: false,
  },
  {
    issueId: 3132,
    failureMode: "Rear housing, Top right corner - Crack",
    failingComponent: "Device",
    location: "Rear housing",
    recovery: "Non-Recoverable",
    recoverySteps: "",
    severity: "Failure",
    category: "Mechanical",
    translation: { zh: "后壳右上角裂纹", vi: "Vỏ sau nứt góc trên bên phải" },
    isMappedWithChecks: true,
  },
];

// Issues available for copy from another project (Turquoise)
const issueListForCopy: IIssueForCopy[] = [
  { issueId: 3426, failingComponent: "Display", failureMode: "Flash", recovery: "Requires User Intervention", recoverySteps: "pressing power button" },
  { issueId: 3416, failingComponent: "Display", failureMode: "Flicker", recovery: "Self-Recoverable" },
  { issueId: 3401, description: "Device - Cannot power on" },
  { issueId: 3326, description: "Display - Flash(recover by pressing mute button)" },
  { issueId: 3316, description: "AUT Station - Fail" },
  { issueId: 3301, description: "ARF Station - Fail" },
  { issueId: 3226, description: "Speaker - Doesn't work" },
  { issueId: 3216, description: "Microphone - Doesn't work" },
  { issueId: 3201, description: "Display - Crack" },
  { issueId: 3198, description: "Battery - Swelling" },
  { issueId: 3185, description: "Touch - Unresponsive area" },
];

axiosMockAdapterInstance.onGet(apiConfig.fetch_IssueList).reply(200, {
  data: [...issueListStore],
  isSuccess: true,
  message: "Issue list fetched successfully",
});

axiosMockAdapterInstance.onPost(apiConfig.add_Issue).reply(config => {
  const body = JSON.parse(config.data);
  const newIssue: IIssueListItem = {
    ...body,
    issueId: Math.max(...issueListStore.map(i => i.issueId)) + 1,
    isMappedWithChecks: false,
  };
  issueListStore.push(newIssue);
  return [200, { data: { success: true }, isSuccess: true, message: "Issue added successfully" }];
});

axiosMockAdapterInstance.onPost(apiConfig.edit_Issue).reply(config => {
  const body = JSON.parse(config.data) as IIssueListItem;
  const idx = issueListStore.findIndex(i => i.issueId === body.issueId);
  if (idx >= 0) issueListStore[idx] = { ...issueListStore[idx], ...body };
  return [200, { data: { success: true }, isSuccess: true, message: "Issue updated successfully" }];
});

axiosMockAdapterInstance.onDelete(apiConfig.delete_Issue).reply(config => {
  const body = JSON.parse(config.data);
  const idx = issueListStore.findIndex(i => i.issueId === body.issueId);
  if (idx >= 0) issueListStore.splice(idx, 1);
  return [200, { data: { success: true }, isSuccess: true, message: "Issue deleted successfully" }];
});

axiosMockAdapterInstance.onPost(apiConfig.copy_Issue).reply(config => {
  const body = JSON.parse(config.data);
  const copiedIds: number[] = body.issueIdList ?? [];
  const copied = issueListForCopy
    .filter(i => copiedIds.includes(i.issueId))
    .map(i => ({
      issueId: Math.max(...issueListStore.map(x => x.issueId)) + issueListStore.length + Math.random() * 100,
      failureMode: i.description ?? i.failureMode ?? "",
      recovery: "Non-Recoverable" as const,
      recoverySteps: "",
      severity: "Failure" as const,
      category: "Functional" as const,
      translation: {},
      isMappedWithChecks: false,
    }));
  issueListStore.push(...copied);
  return [200, { data: { copiedCount: copied.length }, isSuccess: true, message: `${copied.length} issue(s) copied successfully` }];
});

axiosMockAdapterInstance.onPost(apiConfig.merge_Issue).reply(config => {
  const body = JSON.parse(config.data);
  const keepIdx = issueListStore.findIndex(i => i.issueId === body.issueIdToKeep);
  if (keepIdx < 0) return [400, { isSuccess: false, message: "Keep issue not found" }];

  const removeNumbers: number[] = body.issueIdToMergeList ?? [];
  const toRemove = issueListStore.filter(i => removeNumbers.includes(i.issueId));

  // Merge translations: combine all translations, separated by ";"
  const mergedTranslation = { ...issueListStore[keepIdx].translation };
  for (const removed of toRemove) {
    for (const [lang, text] of Object.entries(removed.translation ?? {})) {
      const key = lang as keyof typeof mergedTranslation;
      if (mergedTranslation[key]) {
        mergedTranslation[key] = `${mergedTranslation[key]};${text}`;
      } else {
        mergedTranslation[key] = text;
      }
    }
  }
  issueListStore[keepIdx].translation = mergedTranslation;

  // Remove the merged issues
  for (const id of removeNumbers) {
    const idx = issueListStore.findIndex(i => i.issueId === id);
    if (idx >= 0) issueListStore.splice(idx, 1);
  }

  return [200, { data: { success: true }, isSuccess: true, message: "Issues merged successfully" }];
});

axiosMockAdapterInstance.onGet(apiConfig.fetch_IssueListForCopy).reply(200, {
  data: issueListForCopy,
  isSuccess: true,
  message: "Issue list for copy fetched successfully",
});

// ── UV Visualizer ──────────────────────────────────────────────────────────
import uvColorTableSample from "@/modules/UVVisualizer/__fixtures__/uvColorTable.json";

// UV Visualizer — GetUvColorTable (GET) returns a BaseResponse envelope.
axiosMockAdapterInstance.onGet(apiConfig.fetch_UVVisualizer_ColorTable).reply(200, {
  isSuccess: true,
  code: 200,
  data: uvColorTableSample,
});
